import { Component, ElementRef, NgZone } from '@angular/core';
import { HeroMotifBase, RGB } from '../hero-motif/hero-motif.base';

const LOOP = 40;
const W0 = Math.PI * 2 / LOOP;

/** "Eiffel Tower Silhouette" by GDJ, Open Clip Art Library, CC0 1.0 (Wikimedia Commons); viewBox 0 0 736 1920. */
// the tower's distance to its middle (owner: a little forward in the park) and its size against the
// real 330 m (owner: a little smaller, so its beacon shows under the top of the stage)
const TOWER_Z = 840;
const TOWER_SCALE = 0.817;
// and set 5 px lower on the screen (owner: 20 down, then 5 up three times)
const TOWER_DROP = 5;
const EIFFEL_D = 'M371,1c0,1.7928,0,3.5856,0,5.6754c3.1156,0.2445,6.3162,1.6389,6.4228-3.3596c0.3531,2.0479,0.7062,4.0958,1.1506,6.6732c-2.4914,0.2529-4.7224,0.4794-7.3257,0.7436c-0.1255,1.4959-0.3484,2.9238-0.3499,4.352c-0.0223,21.8303-0.2111,43.6641,0.1733,65.4876c0.0652,3.7031,2.8299,7.3002,3.9487,11.0648c0.6826,2.297,1.0436,4.8735,0.7607,7.2297c-0.4067,3.3867,2.2062,7.6776-2.5941,10.0617c-0.3336,0.1657-0.1742,2.3479,0.3924,3.1329c3.2401,4.4883,3.2336,13.2663,0.1163,17.4642c-0.6358,0.8563-0.59,3.0179,0.0615,3.8931c2.897,3.8923,3.0266,13.6131,0.1478,17.1991c-0.6794,0.8462-0.9098,3.3442-0.6836,3.4353c4.4993,1.8116,1.9562,5.6888,2.6925,8.5564c0.3793,1.4774,0.6083,3.7155,1.5986,4.2039c12.0382,5.9364,18.5288,16.317,23.2351,28.2197c0.4892,1.2372,1.0104,2.4618,1.6767,4.0808c3.015,0,6.1187,0,9.5057,0c0,5.1783,0,9.9422,0,14.4297c-2.0557,0.9646-3.9575,1.857-5.8593,2.7493c1.4883,0.8992,2.9766,1.7984,5.1732,3.1254c0,4.6091,0,10.1639,0,16.047c-1.5847,0.2376-3.1574,0.4734-4.7447,0.7114c-1.5942,4.1084,1.0082,4.0649,3.7014,4.0146c2.4889-0.0465,4.9794-0.0099,8.2015-0.0099c0.6693,9.5112,1.3228,18.7991,1.8456,26.2295c-4.1078,3.606-7.3062,5.6669-9.5226,8.4969c-7.1563,9.1371-9.1574,20.2626-10.5312,31.3322c-0.9783,7.8829-1.1354,15.9439-0.846,23.8959c2.5145,69.0996,4.8686,138.2079,7.9481,207.2834c3.4505,77.3964,7.2257,154.7828,11.579,232.133c3.3885,60.2062,7.5691,120.3732,11.9834,180.5146c3.2673,44.5142,6.6931,89.0441,11.4969,133.4102c4.3712,40.37,10.6844,80.5303,16.1697,120.7791c0.7855,5.7638,1.7287,11.5063,2.6687,17.7203c7.3515,0,14.6183,0,21.7651,0c0.8004,4.2999,1.6515,8.0909,2.1089,11.9291c0.1024,0.8595-1.0937,2.6292-1.8301,2.7092c-4.3879,0.4767-6.4663,3.4833-7.6161,7.031c-3.408,10.5153-5.4131,21.1913-2.6185,32.2673c15.9972,63.4027,31.4259,126.9556,48.1893,190.1547c6.8099,25.6736,16.5431,50.5687,24.8087,75.863c0.9349,2.8607,2.542,3.3431,5.1542,3.3091c8.7884-0.1149,17.5792-0.0437,26.3507-0.0437c0,15.3308,0,30.0577,0,45.1138c3.3297,0.3149,6.3163,0.5974,9.6169,0.9095c-7.0198,9.2853-10.4893,25.4117-7.3981,33.9413c-0.9554,0.5508-1.9647,1.1327-3.1775,1.8319c10.9536,22.4906,21.7955,44.7814,32.6629,67.0597c31.6002,64.7809,63.2236,129.5507,94.7839,194.351c1.8188,3.7345,4.1771,6.1594,8.1887,8.0043c6.1494,2.8286,11.6587,7.0488,17.4405,10.679c-1.4589,6.6013,3.6301,9.3694,7.3774,12.9135c-1.3333,0.3334-2.6664,0.9567-4.0001,0.958C684,1921.0078,635,1921,586,1921c1.1193-4.0438,3.201-8.076-0.7626-11.923c-0.5778-0.561-0.3848-2.851,0.2827-3.6021c3.254-3.6606,4.5316-7.8728,4.5386-12.6567c0.0457-31.0323-10.3522-59.001-24.8798-85.8313c-30.874-57.0192-103.08-107.4421-175.689-112.4075c-60.7076-4.1514-114.576,11.485-162.1179,49.3146c-41.5111,33.0313-68.164,75.2056-77.6483,127.5934c-2.1008,11.6042-5.3472,23.9421,3.3321,34.8429c0.4419,0.5548,0.2975,2.312-0.2269,2.7843c-4.1758,3.7604-1.7248,7.8563-0.8289,11.8854c-49,0-98,0.0078-146.9999-0.0419C3.6664,1920.9568,2.3333,1920.3334,1,1920c3.6146-3.4304,8.4598-6.1499,7.3925-13.2753c6.372-3.5896,13.4044-7.3024,20.1397-11.4927c2.1027-1.3081,3.8861-3.6693,5.0007-5.9473c29.9281-61.1628,59.7509-122.3773,89.5889-183.5844c11.381-23.3461,22.7383-46.7039,34.1546-70.0326c1.4243-2.9103,2.392-5.4476,1.6747-9.0864c-0.9246-4.6901,0.3462-9.7689-0.1221-14.6034c-0.6998-7.2241-2.0268-14.4061-8.4045-20.6892c3.6515-0.332,6.5798-0.5984,10.0032-0.9097c0-14.8922,0-29.6169,0-45.1871c7.3595,0,14.7742,0.0011,22.1888-0.0004c8.2023-0.0016,7.9718-0.0938,10.9848-7.7145c20.2079-51.1115,32.0708-104.6132,45.36-157.7092c8.8488-35.3546,17.9749-70.642,26.491-106.0763c2.5739-10.7094,0.6228-21.54-3.8424-31.5874c-1.0218-2.2992-4.3841-3.5082-6.5254-5.3833c-0.9234-0.8085-2.186-2.1141-2.0802-3.0577c0.4133-3.6864,1.312-7.3185,2.1396-11.5261c6.9288,0,14.18,0,21.7236,0c2.7094-18.2045,5.6919-35.9119,7.9254-53.7131c5.4102-43.1206,10.9931-86.2308,15.5021-129.4501c3.3697-32.2986,5.2884-64.7524,7.6434-97.1525c3.0315-41.7084,6.0662-83.4186,8.6977-125.1534c2.097-33.2574,3.6509-66.5499,5.3405-99.8322c2.602-51.2566,5.1968-102.5138,7.6393-153.7781c2.2126-46.4393,4.4301-92.8802,6.2448-139.336c1.379-35.3001,2.4617-70.6198,2.9919-105.941c0.2055-13.6946-2.473-27.2204-9.26-39.4546c-2.4683-4.4493-5.2104-9.0273-11.9352-9.925c0.6554-9.2014,1.3083-18.3676,1.9683-27.6327c4.3059-0.5349,8.2806-0.9966,12.2256-1.6399c0.1522-0.0248,0.0194-1.7968,0.0194-2.9919c-1.7043-0.1716-3.1521-0.3174-5.0156-0.505c0-5.6203,0-11.176,0-16.4994c1.7855-0.9703,3.4507-1.8752,5.1159-2.7801c-1.7348-0.8528-3.4696-1.7057-5.7657-2.8345c0-4.1901,0-9.0668,0-14.3386c3.2409,0,6.3452,0,9.5052,0c3.7485-10.2509,8.1871-19.7142,16.465-26.7751c0.7602-0.6484,1.3844-1.6034,2.2567-1.9492c6.0888-2.4132,9.1331-6.4755,7.8633-13.2819c-0.1209-0.648,1.4228-1.4692,1.7392-2.3697c0.4335-1.2336,1.0584-3.0164,0.5144-3.8763c-3.378-5.3395-3.3705-11.843,0.165-17.8266c0.4951-0.8379,0.5005-2.4764,0.003-3.3075c-3.515-5.871-3.5817-12.7472-0.1718-17.7853c0.5429-0.8021,0.7231-2.817,0.2311-3.2044c-5.6829-4.4737-1.6049-10.4433-2.3514-15.611c-0.2892-2.0013,2.1177-4.2605,2.7246-6.5535c0.9317-3.52,1.896-7.1659,1.9294-10.7669c0.1837-19.8314,0.0887-39.6654,0.0893-59.4985c0.0001-1.7889,0-3.5777,0-5.5841c-2.639-0.2526-4.748-0.4544-7.4671-0.7146c0.3003-2.3036,0.5806-4.4544,0.7749-5.9445c1.7897,1.1066,3.6452,2.2539,6.5239,4.0338c0-3.5812,0-5.3726,0-7.164C368.3333,1,369.6667,1,371,1z M324.441,1328.0408c-11.922,72.7325-22.6619,145.1182-38.1751,216.7688c55.1111,0,110.597,0,165.2077,0c-12.8733-72.3667-25.707-144.5107-38.561-216.7688C383.658,1328.0408,354.2241,1328.0408,324.441,1328.0408z';

/** A pigeon flying over the gardens. */
interface Pigeon {
  x: number;
  y: number;
  base: number;
  dir: 1 | -1;
  speed: number;
  size: number;
  bob: number;
  phase: number;
  flap: number;
  rank: number;
  shown: number;
}

/** A car on a road, in metres: its place along the road, the road, its speed. */
interface Car {
  u: number;
  road: number;
  speed: number;
  col: RGB;
  /** Out only while the counter is strong enough for its rank; fading in and out. */
  rank: number;
  shown: number;
}

/**
 * Paris's hero board (2026-10-17), after the owner's photograph (the theme's cover is AI made): the view
 * from the Trocadéro at the blue hour, in true perspective (a camera on the terrace 30 m up, looking along the axis; every
 * object placed in metres and projected). A plum sky burning rose and orange at the horizon, level clouds
 * lit from below; the Warsaw fountains' long pool and its jets, the sloping gardens, rows of autumn trees,
 * Haussmann blocks to either side; the Seine and the Pont d'Iéna; the Eiffel Tower in its golden light on
 * the Champ de Mars; the Invalides' dome and the city to the horizon in the haze. Cars drive the quays and
 * the avenues. The counter makes the fountains leap and brings out the pigeons. The page's
 * wallpaper is the tower's sparkles alone. Sized by the stage's height.
 */
@Component( {
  selector: 'app-hero-paris',
  template: '<canvas #canvas class="hpar-canvas" aria-hidden="true"></canvas>',
  styles: [ ':host { display: block; position: absolute; inset: 0; overflow: hidden; pointer-events: none; }',
    '.hpar-canvas { display: block; position: absolute; inset: 0; }' ],
} )
export class HeroParisComponent extends HeroMotifBase {

  private sky: HTMLCanvasElement | null = null;
  /** The tower's illumination, dim at rest, glowing gold while the counter counts (owner). */
  private towerLights: HTMLCanvasElement | null = null;
  private towerShape: Path2D | null = null;
  /** The front face's placement on the stage: its foot's x and y and the svg's scale. */
  private towerAt: [ number, number, number ] | null = null;
  /** The tower's star points, on screen, with a phase each. */
  private stars: [ number, number, number ][] = [];
  /** The beacon on the tower's top, on screen. */
  private beacon: [ number, number ] | null = null;
  /** One searchlight's cone, painted once per palette: a soft gaussian across, fading along its length. */
  private beamSprite: HTMLCanvasElement | null = null;
  private back: HTMLCanvasElement | null = null;
  private front: HTMLCanvasElement | null = null;
  private clouds: HTMLCanvasElement | null = null;
  private cloudOff = 0;
  private pigeons: Pigeon[] = [];
  private cars: Car[] = [];
  private scaleK = 1;
  // the camera: eye height (m), focal length and horizon (px), the vanishing point's x (px)
  private eye = 30;
  private F = 0;
  private hz = 0;
  private vx = 0;

  constructor( zone: NgZone, host: ElementRef<HTMLElement> ) {
    super( zone, host );
    this.loop = LOOP;
    this.ease = 1.2;
  }

  protected colorsChanged(): void {
    this.back = null;
    this.front = null;
    this.beamSprite = null;
  }

  /** Project a point: x across (metres from the axis), y up, z along the axis away from us. */
  private P( x: number, y: number, z: number ): [ number, number ] {
    return [ this.vx + this.F * x / z, this.hz - this.F * ( y - this.eye ) / z ];
  }

  protected build(): void {
    const W = this.width;
    const H = this.height;
    const k = this.scaleK = Math.max( 0.55, Math.min( 1.25, H / 760 ) );
    this.F = 1.65 * H;
    this.hz = 0.6 * H;
    // the tower in the very middle (owner)
    this.vx = W / 2;
    this.back = null;
    this.front = null;
    const r = this.seededLocal( 31 );
    this.pigeons = [];
    for ( let i = 0; i < 24; i++ ) {
      const far = r();
      this.pigeons.push( {
        x: r() * W, y: 0, base: H * ( 0.06 + 0.4 * r() ), dir: r() < 0.5 ? 1 : -1,
        speed: ( 60 + r() * 40 ) * k * ( 1 - 0.4 * far ), size: ( 16 - 7 * far ) * k,
        bob: ( 5 + r() * 10 ) * k, phase: r() * Math.PI * 2, flap: r() * 10,
        rank: i === 0 ? 0 : i === 1 ? 0.05 : r(), shown: 0,
      } );
    }
    // the traffic: along the quay on our bank of the Seine (road 0, across, both ways) and up the two
    // avenues beside the gardens (roads 1 and 2, along the axis)
    this.cars = [];
    const palette: RGB[] = [ [ 200, 66, 58 ], [ 240, 228, 200 ], [ 127, 181, 166 ], [ 241, 201, 112 ], [ 59, 75, 107 ], [ 138, 47, 62 ], [ 40, 40, 44 ], [ 200, 200, 196 ] ];
    // twice as many as at rest, the rest called out by the counter (owner: more traffic on the charge)
    for ( let i = 0; i < 90; i++ ) {
      const road = i % 9 < 5 ? 0 : i % 9 < 7 ? 1 : 2;
      this.cars.push( { u: road ? 140 + r() * 320 : -233 + r() * 466, road, speed: ( r() < 0.5 ? 1 : -1 ) * ( 9 + r() * 5 ), col: palette[ Math.floor( r() * palette.length ) ], rank: r(), shown: 0 } );
    }
  }

  protected paint( ctx: CanvasRenderingContext2D, dt: number ): void {
    const W = this.width;
    const H = this.height;
    if ( this.frozen ) {
      // the page's wallpaper: the tower's star-like sparkles alone, still, all down the page (owner: not
      // the pigeons)
      this.drawWallSparkles( ctx );
      return;
    }
    if ( !this.back ) { this.bake( ctx.getTransform().a ); }
    if ( !this.back || !this.front ) { return; }
    // the sky, the clouds drifting behind the tower (owner), then the city and the tower
    if ( this.sky ) { ctx.drawImage( this.sky, 0, 0, W, H ); }
    if ( this.clouds ) {
      if ( dt > 0 ) { this.cloudOff = ( this.cloudOff + dt * 5 * this.scaleK ) % W; }
      const off = Math.round( this.cloudOff );
      ctx.drawImage( this.clouds, off, 0, W, H );
      ctx.drawImage( this.clouds, off - W, 0, W, H );
    }
    ctx.drawImage( this.back, 0, 0, W, H );
    this.drawCars( ctx, dt );
    this.drawBeacon( ctx );
    if ( this.towerLights ) {
      ctx.save();
      ctx.globalCompositeOperation = 'lighter';
      ctx.globalAlpha = 0.1 + 0.6 * this.energy;
      ctx.drawImage( this.towerLights, 0, 0, W, H );
      ctx.restore();
    }
    this.drawTowerGlory( ctx );
    ctx.drawImage( this.front, 0, 0, W, H );
    this.drawFountains( ctx );
  }

  /**
   * On the charge (owner's photograph): white star points flashing on the tower, each a bright core with
   * a cross of light, and the beacon's two searchlight beams sweeping slowly round the sky.
   */
  private drawTowerGlory( ctx: CanvasRenderingContext2D ): void {
    const e = this.energy;
    if ( !this.beacon ) { return; }
    const t = performance.now() / 1000;
    const k = this.scaleK;
    // the beacon's beams now and then at rest (owner), for eight seconds in thirty, always on the charge
    const cyc = ( t % 30 ) / 30;
    const now = cyc < 0.27 ? Math.sin( Math.PI * cyc / 0.27 ) : 0;
    const beamA = Math.max( e, now * 0.8 );
    ctx.save();
    ctx.globalCompositeOperation = 'lighter';
    // a few at rest, all of them on the charge (owner); each tinted a little by one of the theme's
    // colours (owner), its heart near white
    const ee = 0.15 + 0.85 * e;
    const tints = this.five().map( c => [ this.mix( c, [ 255, 255, 245 ], 0.55 ), this.mix( c, [ 255, 245, 230 ], 0.25 ) ] );
    // the lights' colours falling on the iron round them (owner), only on the tower's own lattice
    if ( this.towerShape && this.towerAt ) {
      const m = ctx.getTransform();
      const [ tx, ty, ts ] = this.towerAt;
      ctx.translate( tx, ty ); ctx.scale( ts, ts ); ctx.translate( -368, -1920 );
      ctx.save();
      ctx.clip( this.towerShape );
      ctx.setTransform( m );
      for ( const [ x, y, ph ] of this.stars ) {
        const a = ee * Math.pow( 0.5 + 0.5 * Math.sin( t * 2.2 + ph * 40 ), 2 );
        if ( a < 0.05 ) { continue; }
        const halo = tints[ Math.floor( ph * 97 ) % tints.length ][ 1 ];
        const r = 16 * k;
        const g = ctx.createRadialGradient( x, y, 0, x, y, r );
        g.addColorStop( 0, this.rgba( halo, a * 0.4 ) );
        g.addColorStop( 1, this.rgba( halo, 0 ) );
        ctx.fillStyle = g;
        ctx.fillRect( x - r, y - r, r * 2, r * 2 );
      }
      ctx.restore();
      ctx.setTransform( m );
    }
    for ( const [ x, y, ph ] of this.stars ) {
      const [ heart, halo ] = tints[ Math.floor( ph * 97 ) % tints.length ];
      const a = ee * Math.pow( 0.5 + 0.5 * Math.sin( t * 2.2 + ph * 40 ), 2 );
      if ( a < 0.05 ) { continue; }
      const r = 2.6 * k * ( 0.6 + a );
      const g = ctx.createRadialGradient( x, y, 0, x, y, r );
      g.addColorStop( 0, this.rgba( heart, a ) );
      g.addColorStop( 1, this.rgba( halo, 0 ) );
      ctx.fillStyle = g;
      ctx.fillRect( x - r, y - r, r * 2, r * 2 );
      ctx.strokeStyle = this.rgba( heart, a * 0.7 );
      ctx.lineWidth = 0.6;
      ctx.beginPath(); ctx.moveTo( x - r * 2.2, y ); ctx.lineTo( x + r * 2.2, y ); ctx.moveTo( x, y - r * 2.2 ); ctx.lineTo( x, y + r * 2.2 ); ctx.stroke();
    }
    // the searchlight beams from the top, sweeping round (owner: realistic, smooth gradients): each a
    // soft cone, widening and fading with distance; seen side on it is long and thin, turning toward us
    // it shortens, widens and brightens, and the lamp flares when one points straight at us
    const [ bx, by ] = this.beacon;
    const H = this.height;
    if ( beamA > 0.01 ) {
      const beam = this.mix( this.five()[ 3 ], [ 255, 250, 240 ], 0.6 );
      if ( !this.beamSprite ) { this.beamSprite = this.makeBeam( beam ); }
      const sweep = t * 0.35;
      let flare = 0;
      for ( const off of [ 0, Math.PI ] ) {
        const a = sweep + off;
        const dir = Math.cos( a ), toward = Math.sin( a );
        const side = Math.abs( dir );
        // the reach follows the turn without a jump (owner): it shrinks through zero as the beam swings
        // past us, the cone then rising nearly upright, short, into the lamp's flare
        const ex = bx + dir * this.width * 0.95, ey = by - H * 0.07 - toward * H * 0.05;
        const ang = Math.atan2( ey - by, ex - bx ), dist = Math.hypot( ex - bx, ey - by );
        const spread = H * 0.028 * ( 1 + 0.8 * ( 1 - side ) );
        const alpha = beamA * ( 0.32 + 0.4 * ( 1 - side ) * ( toward > 0 ? 1 : 0.25 ) );
        ctx.save();
        ctx.globalAlpha = Math.min( 1, alpha );
        ctx.translate( bx, by );
        ctx.rotate( ang );
        ctx.drawImage( this.beamSprite, 0, -spread, dist, spread * 2 );
        ctx.restore();
        if ( toward > 0 ) { flare = Math.max( flare, Math.pow( 1 - side, 3 ) ); }
      }
      // the lamp's own glow, flaring only a little as a beam swings to face us (owner: it grew too big)
      const fr = H * ( 0.02 + 0.012 * flare );
      const fg = ctx.createRadialGradient( bx, by, 0, bx, by, fr );
      fg.addColorStop( 0, this.rgba( [ 255, 252, 245 ], beamA * ( 0.35 + 0.3 * flare ) ) );
      fg.addColorStop( 0.25, this.rgba( beam, beamA * ( 0.15 + 0.15 * flare ) ) );
      fg.addColorStop( 1, this.rgba( beam, 0 ) );
      ctx.globalAlpha = 1;
      ctx.fillStyle = fg;
      ctx.fillRect( bx - fr, by - fr, fr * 2, fr * 2 );
    }
    ctx.restore();
  }

  /** A searchlight's cone pointing right from its apex at the left middle, in its colour. */
  private makeBeam( col: RGB ): HTMLCanvasElement {
    const w = 512, h = 128;
    const cv = document.createElement( 'canvas' );
    cv.width = w; cv.height = h;
    const c = cv.getContext( '2d' )!;
    const img = c.createImageData( w, h );
    for ( let x = 0; x < w; x++ ) {
      const t = x / w;
      const halfW = ( 0.03 + 0.97 * t ) * h / 2;
      const along = Math.pow( 1 - t, 1.5 ) * Math.min( 1, t * 40 );
      for ( let y = 0; y < h; y++ ) {
        const d = ( y - h / 2 + 0.5 ) / halfW;
        const a = along * ( 0.7 * Math.exp( -d * d * 2.4 ) + 0.5 * Math.exp( -d * d * 14 ) * ( 1 - t ) );
        const i = ( y * w + x ) * 4;
        img.data[ i ] = col[ 0 ]; img.data[ i + 1 ] = col[ 1 ]; img.data[ i + 2 ] = col[ 2 ];
        img.data[ i + 3 ] = Math.round( Math.min( 1, a ) * 255 );
      }
    }
    c.putImageData( img, 0, 0 );
    return cv;
  }

  /** The beacon on the tower's top, blinking (owner): a second on, a second off, softly. */
  private drawBeacon( ctx: CanvasRenderingContext2D ): void {
    if ( !this.beacon ) { return; }
    const t = performance.now() / 1000;
    const on = Math.max( 0, Math.sin( t * Math.PI ) );
    const a = Math.pow( on, 0.5 );
    if ( a < 0.02 ) { return; }
    const [ x, y ] = this.beacon;
    const r = Math.max( 2, this.F * 3 / 900 ) * ( 0.8 + 0.4 * a );
    const g = ctx.createRadialGradient( x, y, 0, x, y, r * 2.5 );
    g.addColorStop( 0, `rgba(255,250,240,${ a })` );
    g.addColorStop( 0.3, `rgba(255,236,210,${ a * 0.6 })` );
    g.addColorStop( 1, 'rgba(255,230,200,0)' );
    ctx.fillStyle = g;
    ctx.fillRect( x - r * 2.5, y - r * 2.5, r * 5, r * 5 );
  }

  /**
   * The Warsaw fountains along the pool: a row of jets rising and falling on the loop, their spray soft at
   * the top; when the counter counts they leap higher and the great cannons at the pool's end fire.
   */
  private drawFountains( ctx: CanvasRenderingContext2D ): void {
    const t = this.time * W0;
    const e = this.energy;
    // as at the Trocadéro: a line of tall jets down the pool's middle, smaller bouquets to either side,
    // spaced well apart; each a rising column falling back in arcs to both sides, a mist round its foot
    for ( let z = 392; z >= 168; z -= 28 ) {
      for ( const x of [ -11, 0, 11 ] ) {
        const big = x === 0;
        const ph = z * 0.05 + x * 0.4;
        const hgt = ( big ? 9 : 4 ) * ( 0.8 + 0.2 * Math.sin( t * 3 + ph ) ) * ( 1 + 1.3 * e );
        const s = this.F / z;
        const [ bx, by ] = this.P( x, 0.3, z ), [ tx, ty ] = this.P( x, hgt, z );
        // the mist at its foot
        const mr = s * ( big ? 3.2 : 1.8 );
        const mist = ctx.createRadialGradient( bx, by, 0, bx, by, mr );
        mist.addColorStop( 0, 'rgba(255,244,250,0.35)' );
        mist.addColorStop( 1, 'rgba(255,244,250,0)' );
        ctx.fillStyle = mist;
        ctx.fillRect( bx - mr, by - mr, mr * 2, mr * 2 );
        // the column: a slender core, brighter, thinning as it rises
        const w = Math.max( 0.6, s * ( big ? 0.35 : 0.22 ) );
        const col = ctx.createLinearGradient( 0, ty, 0, by );
        col.addColorStop( 0, 'rgba(255,250,252,0.15)' );
        col.addColorStop( 0.2, 'rgba(255,250,252,0.85)' );
        col.addColorStop( 1, 'rgba(255,246,250,0.55)' );
        ctx.fillStyle = col;
        ctx.beginPath();
        ctx.moveTo( bx - w, by ); ctx.lineTo( tx - w * 0.3, ty ); ctx.lineTo( tx + w * 0.3, ty ); ctx.lineTo( bx + w, by );
        ctx.closePath(); ctx.fill();
        // the water falling back from the top in arcs to both sides, breaking into drops
        ctx.lineCap = 'round';
        for ( const d of [ -1, 1 ] ) {
          for ( let q = 0; q < 3; q++ ) {
            const spread = ( big ? 1.6 : 1 ) * ( 0.5 + q * 0.35 );
            const pts: [ number, number ][] = [];
            for ( let u = 0; u <= 1.001; u += 0.1 ) { pts.push( this.P( x + d * spread * u, hgt * ( 1 - u * u ) + 0.3, z ) ); }
            ctx.strokeStyle = `rgba(255,248,252,${ 0.45 - q * 0.1 })`;
            ctx.lineWidth = Math.max( 0.5, s * 0.08 );
            ctx.beginPath();
            pts.forEach( ( [ px, py ], k ) => k ? ctx.lineTo( px, py ) : ctx.moveTo( px, py ) );
            ctx.stroke();
          }
        }
      }
    }
    // the cannons at the far end of the pool, firing toward the Seine on the charge
    if ( e > 0.05 ) {
      for ( const x of [ -20, -10, 10, 20 ] ) {
        const pts: [ number, number ][] = [];
        for ( let q = 0; q <= 12; q++ ) {
          const u = q / 12;
          // from the pool's sides toward its middle, landing in the water (owner: they fell on land)
          pts.push( this.P( x * ( 1 - u * 0.55 ), 0.5 + 9 * e * Math.sin( Math.PI * u ), 392 + 26 * u ) );
        }
        ctx.strokeStyle = `rgba(255,246,250,${ 0.5 * e })`;
        ctx.lineWidth = Math.max( 1, this.F / 420 * 0.8 );
        ctx.lineCap = 'round';
        ctx.beginPath();
        pts.forEach( ( [ px, py ], i ) => i ? ctx.lineTo( px, py ) : ctx.moveTo( px, py ) );
        ctx.stroke();
      }
    }
  }

  /** The cars driving the quay and the avenues, small boxes in perspective with their lights. */
  private drawCars( ctx: CanvasRenderingContext2D, dt: number ): void {
    const P = ( x: number, y: number, z: number ) => this.P( x, y, z );
    const poly = ( pts: [ number, number ][], fill: string ) => {
      ctx.fillStyle = fill;
      ctx.beginPath();
      pts.forEach( ( [ x, y ], i ) => i ? ctx.lineTo( x, y ) : ctx.moveTo( x, y ) );
      ctx.closePath();
      ctx.fill();
    };
    const items: [ number, () => void ][] = [];
    const share = 0.4 + 0.6 * this.energy;
    for ( const c of this.cars ) {
      const want = c.rank <= share ? 1 : 0;
      c.shown = dt > 0 ? c.shown + ( want - c.shown ) * Math.min( 1, dt * 0.8 ) : want;
      if ( dt > 0 ) {
        c.u += c.speed * dt;
        // the quay's road ends at the street along the blocks
        if ( c.road === 0 ) { if ( c.u > 233 ) { c.u = -233; } else if ( c.u < -233 ) { c.u = 233; } }
        else if ( c.u > 470 ) { c.u = 140; } else if ( c.u < 140 ) { c.u = 470; }
      }
      if ( c.shown < 0.03 ) { continue; }
      const col = this.mix( c.col, [ 120, 70, 90 ], 0.25 );
      if ( c.road === 0 ) {
        // along the quay: the car seen from its side
        // each in its own carriageway, by its direction
        const z = c.speed > 0 ? 445.5 : 456.5;
        const x = c.u;
        items.push( [ z, () => {
          ctx.globalAlpha = c.shown;
          const L = 4.2, hb = 0.8, hc = 1.45;
          poly( [ P( x, 0.25, z ), P( x + L, 0.25, z ), P( x + L, hb, z ), P( x, hb, z ) ], this.rgba( col, 1 ) );
          poly( [ P( x + 1, hb, z ), P( x + L - 0.9, hb, z ), P( x + L - 1.3, hc, z ), P( x + 1.4, hc, z ) ], this.rgba( this.mix( col, [ 30, 30, 40 ], 0.4 ), 1 ) );
          poly( [ P( x + 1, hb, z ), P( x + L - 0.9, hb, z ), P( x + L - 0.9, hb, z + 1.7 ), P( x + 1, hb, z + 1.7 ) ], this.rgba( this.mix( col, [ 255, 240, 230 ], 0.15 ), 1 ) );
          const [ lx, ly ] = P( c.speed > 0 ? x + L : x, 0.6, z );
          const g = ctx.createRadialGradient( lx, ly, 0, lx, ly, 3 * this.scaleK );
          g.addColorStop( 0, c.speed > 0 ? 'rgba(255,240,200,0.9)' : 'rgba(255,80,70,0.9)' );
          g.addColorStop( 1, 'rgba(255,200,160,0)' );
          ctx.fillStyle = g;
          ctx.fillRect( lx - 3 * this.scaleK, ly - 3 * this.scaleK, 6 * this.scaleK, 6 * this.scaleK );
        } ] );
      } else {
        // up an avenue beside the gardens: seen from behind or in front
        const x = ( c.road === 1 ? -1 : 1 ) * ( 92 + ( c.speed > 0 ? 3 : -3 ) );
        const z = c.u;
        items.push( [ z, () => {
          ctx.globalAlpha = c.shown;
          const Wd = 1.7, L = 4.2, hb = 0.8, hc = 1.45;
          const side = x > 0 ? x - Wd / 2 : x + Wd / 2;
          poly( [ P( x - Wd / 2, 0.25, z ), P( x + Wd / 2, 0.25, z ), P( x + Wd / 2, hb, z ), P( x - Wd / 2, hb, z ) ], this.rgba( this.mix( col, [ 0, 0, 0 ], 0.2 ), 1 ) );
          poly( [ P( side, 0.25, z ), P( side, hb, z ), P( side, hb, z + L ), P( side, 0.25, z + L ) ], this.rgba( col, 1 ) );
          poly( [ P( x - Wd / 2, hb, z ), P( x + Wd / 2, hb, z ), P( x + Wd / 2, hb, z + L ), P( x - Wd / 2, hb, z + L ) ], this.rgba( this.mix( col, [ 255, 240, 230 ], 0.15 ), 1 ) );
          poly( [ P( x - Wd / 2 + 0.1, hb, z + 1 ), P( x + Wd / 2 - 0.1, hb, z + 1 ), P( x + Wd / 2 - 0.1, hc, z + 1.4 ), P( x - Wd / 2 + 0.1, hc, z + 1.4 ) ], 'rgba(40,40,52,1)' );
          for ( const lx of [ x - Wd / 2 + 0.25, x + Wd / 2 - 0.25 ] ) {
            const [ px, py ] = P( lx, 0.6, z );
            const g = ctx.createRadialGradient( px, py, 0, px, py, 2.4 * this.scaleK );
            g.addColorStop( 0, c.speed > 0 ? 'rgba(255,80,70,0.9)' : 'rgba(255,240,200,0.9)' );
            g.addColorStop( 1, 'rgba(255,200,160,0)' );
            ctx.fillStyle = g;
            ctx.fillRect( px - 2.4 * this.scaleK, py - 2.4 * this.scaleK, 4.8 * this.scaleK, 4.8 * this.scaleK );
          }
        } ] );
      }
    }
    items.sort( ( a, b ) => b[ 0 ] - a[ 0 ] );
    for ( const [ , d ] of items ) { d(); }
    ctx.globalAlpha = 1;
  }

  /**
   * The pigeons wheeling over the gardens: quick wingbeats with short glides, a few at rest, many when
   * the counter counts; called out somewhere and fading in.
   */
  private drawPigeons( ctx: CanvasRenderingContext2D, dt: number ): void {
    const W = this.width;
    const e = this.energy;
    const share = 0.1 + 0.9 * e;
    for ( const p of this.pigeons ) {
      const want = p.rank <= share ? 1 : 0;
      if ( dt > 0 && want && p.shown < 0.02 ) { p.x = Math.random() * W; }
      p.shown = dt > 0 ? p.shown + ( want - p.shown ) * Math.min( 1, dt * 0.6 ) : want;
      if ( dt > 0 ) {
        p.x += p.dir * p.speed * ( 1 + 0.5 * e ) * dt;
        p.phase += dt * 0.5;
        p.flap += dt;
        const m = p.size * 3;
        if ( p.x > W + m ) { p.x = -m; } else if ( p.x < -m ) { p.x = W + m; }
      }
      if ( p.shown < 0.02 ) { continue; }
      p.y = p.base + Math.sin( p.phase * 2 ) * p.bob;
      const glide = Math.min( 1, Math.max( 0, ( Math.sin( p.flap * 0.9 ) - 0.5 ) / 0.3 ) );
      const th = p.flap * Math.PI * 2 * 3.2;
      const arm = Math.sin( th ) * ( 1 - glide ) - 0.1 * glide, hand = Math.sin( th - 0.8 ) * ( 1 - glide ) - 0.05 * glide;
      const away = 1 - p.shown;
      ctx.save();
      ctx.globalAlpha = Math.pow( p.shown, 0.7 );
      ctx.translate( p.x, p.y - away * p.bob * 2 );
      ctx.scale( ( 1 - 0.5 * away ) * p.dir, 1 - 0.5 * away );
      this.pigeon( ctx, p.size, arm, hand );
      ctx.restore();
    }
    ctx.globalAlpha = 1;
  }

  /**
   * One pigeon facing right (y down): broad wings in two parts (the arm to the wrist at `arm`, the hand
   * at `hand`; -1 raised, 0 out, 1 lowered), blue grey with two dark bars and dark tips, the round body,
   * the small head with its green and violet sheen at the neck.
   */
  private pigeon( ctx: CanvasRenderingContext2D, s: number, arm: number, hand: number ): void {
    const pose = ( a: number[], t: number ) => t <= 0 ? a[ 1 ] + ( a[ 0 ] - a[ 1 ] ) * -t : a[ 1 ] + ( a[ 2 ] - a[ 1 ] ) * t;
    const bendY = pose( [ -0.42, -0.24, 0.06 ], arm );
    const tipY = pose( [ -0.78, -0.16, 0.42 ], hand ), tipX = pose( [ 0.74, 0.92, 0.8 ], hand );
    const grey: RGB = [ 132, 136, 152 ], dark: RGB = [ 64, 66, 78 ];
    const fill = ( pts: number[][], c: RGB ) => {
      ctx.fillStyle = this.rgba( c, 1 );
      ctx.beginPath();
      pts.forEach( ( [ x, y ], i ) => i ? ctx.lineTo( x * s, y * s ) : ctx.moveTo( x * s, y * s ) );
      ctx.closePath();
      ctx.fill();
    };
    fill( [ [ -0.26, -0.04 ], [ -0.66, -0.08 ], [ -0.66, 0.12 ], [ -0.26, 0.1 ] ], this.mix( grey, dark, 0.3 ) );
    for ( const side of [ -1, 1 ] ) {
      const sh = [ side * 0.1, -0.06 ], bk = [ side * 0.08, 0.12 ];
      const bend = [ side * 0.44, bendY ], end = [ side * tipX, tipY ], trail = [ side * 0.48, bendY + 0.22 ];
      fill( [ sh, bend, end, trail, bk ], this.mix( grey, [ 255, 255, 255 ], Math.max( 0, -hand ) * 0.15 ) );
      const a = [ bend[ 0 ] + ( end[ 0 ] - bend[ 0 ] ) * 0.6, bend[ 1 ] + ( end[ 1 ] - bend[ 1 ] ) * 0.6 ];
      const b = [ trail[ 0 ] + ( end[ 0 ] - trail[ 0 ] ) * 0.6, trail[ 1 ] + ( end[ 1 ] - trail[ 1 ] ) * 0.6 ];
      fill( [ a, end, b ], dark );
    }
    ctx.fillStyle = this.rgba( this.mix( grey, [ 255, 255, 255 ], 0.1 ), 1 );
    ctx.beginPath(); ctx.ellipse( 0, 0.02 * s, 0.32 * s, 0.14 * s, 0, 0, Math.PI * 2 ); ctx.fill();
    ctx.fillStyle = 'rgb(96,140,120)';
    ctx.beginPath(); ctx.ellipse( 0.26 * s, -0.02 * s, 0.1 * s, 0.09 * s, 0, 0, Math.PI * 2 ); ctx.fill();
    ctx.fillStyle = this.rgba( grey, 1 );
    ctx.beginPath(); ctx.arc( 0.36 * s, -0.06 * s, 0.1 * s, 0, Math.PI * 2 ); ctx.fill();
    fill( [ [ 0.44, -0.08 ], [ 0.54, -0.05 ], [ 0.44, -0.03 ] ], [ 60, 50, 50 ] );
  }

  /**
   * The wallpaper: the tower's sparkles scattered still down the page, each a soft heart with four
   * tapering rays, tinted a little by one of the theme's colours like on the tower.
   */
  private drawWallSparkles( ctx: CanvasRenderingContext2D ): void {
    const W = this.width;
    const H = this.height;
    const k = this.scaleK;
    const r = this.seededLocal( 5 );
    const tints = this.five().map( c => [ this.mix( c, [ 255, 255, 245 ], 0.55 ), this.mix( c, [ 255, 245, 230 ], 0.25 ) ] );
    const n = Math.max( 8, Math.round( W * H / 26000 ) );
    for ( let i = 0; i < n; i++ ) {
      const x = r() * W, y = r() * H;
      const [ heart, halo ] = tints[ Math.floor( r() * tints.length ) ];
      const a = 0.35 + r() * 0.5;
      const rad = ( 3 + r() * 4 ) * k;
      const gl = ctx.createRadialGradient( x, y, 0, x, y, rad * 2.4 );
      gl.addColorStop( 0, this.rgba( heart, a ) );
      gl.addColorStop( 0.3, this.rgba( halo, a * 0.45 ) );
      gl.addColorStop( 1, this.rgba( halo, 0 ) );
      ctx.fillStyle = gl;
      ctx.fillRect( x - rad * 2.4, y - rad * 2.4, rad * 4.8, rad * 4.8 );
      // the four rays: long thin soft sprites, the level pair longer
      for ( const [ rot, len ] of [ [ 0, 3.4 ], [ Math.PI / 2, 2.6 ] ] ) {
        ctx.save();
        ctx.translate( x, y );
        ctx.rotate( rot );
        ctx.scale( len, 0.12 );
        const rg = ctx.createRadialGradient( 0, 0, 0, 0, 0, rad );
        rg.addColorStop( 0, this.rgba( heart, a * 0.9 ) );
        rg.addColorStop( 1, this.rgba( heart, 0 ) );
        ctx.fillStyle = rg;
        ctx.beginPath(); ctx.arc( 0, 0, rad, 0, Math.PI * 2 ); ctx.fill();
        ctx.restore();
      }
    }
  }

  /**
   * The still parts, painted once, far to near, in metres projected: the sunset sky, the city to the
   * horizon, the Invalides and Montparnasse, the Champ de Mars, the tower, the Seine and the bridge, the
   * quays (the back layer, the cars drive over it); the trees, the blocks, the gardens and the pool (the
   * front layer, over the cars on the avenues).
   */
  private bake( scale: number ): void {
    const W = this.width;
    const H = this.height;
    const k = this.scaleK;
    const hz = this.hz;
    const F = this.F;
    const [ plum, rose, coral, peach, sky2 ] = this.five();
    const white: RGB = [ 255, 255, 255 ];
    const canvas = () => {
      const c = document.createElement( 'canvas' );
      c.width = Math.ceil( W * scale );
      c.height = Math.ceil( H * scale );
      const g2 = c.getContext( '2d' )!;
      g2.scale( scale, scale );
      return { c, g: g2 };
    };
    const P = ( x: number, y: number, z: number ) => this.P( x, y, z );
    let g: CanvasRenderingContext2D;
    const blob = ( x: number, y: number, r: number, col: RGB, a = 1 ) => {
      const gr = g.createRadialGradient( x, y, 0, x, y, r );
      gr.addColorStop( 0, this.rgba( col, a ) );
      gr.addColorStop( 0.68, this.rgba( col, a * 0.92 ) );
      gr.addColorStop( 1, this.rgba( col, 0 ) );
      g.fillStyle = gr;
      g.fillRect( x - r, y - r, r * 2, r * 2 );
    };
    const poly = ( pts: [ number, number ][], fill: string | CanvasGradient ) => {
      g.fillStyle = fill;
      g.beginPath();
      pts.forEach( ( [ x, y ], i ) => i ? g.lineTo( x, y ) : g.moveTo( x, y ) );
      g.closePath();
      g.fill();
    };
    // the dusk air: far things sink into the horizon's rose glow
    const glow: RGB = this.mix( this.mix( rose, sky2, 0.4 ), white, 0.1 );
    const inAir = ( col: RGB, z: number, strength = 0.8 ) => this.mix( col, this.mix( glow, plum, 0.35 ), ( 1 - Math.exp( -z / 2600 ) ) * strength );
    // the ground in strips: a quad on the ground between x0..x1 and z0..z1
    const ground = ( x0: number, x1: number, z0: number, z1: number, fill: string | CanvasGradient ) => poly( [ P( x0, 0, z0 ), P( x1, 0, z0 ), P( x1, 0, z1 ), P( x0, 0, z1 ) ], fill );
    // one tree seen from a little above, lit from the sunset ahead: its trunk, its crown's shaded side,
    // its body, its lit top facing the glow
    // plane-tree leaves, painted once per tone (owner: the blurred discs read as low resolution): a
    // five-lobed leaf with its midribs, lighter toward its tips
    const leafCache = new Map<string, HTMLCanvasElement>();
    const leaf = ( tint: RGB ) => {
      const key = tint.map( v => Math.round( v / 6 ) ).join( ',' );
      const hit = leafCache.get( key );
      if ( hit ) { return hit; }
      const size = 40;
      const cv = document.createElement( 'canvas' );
      cv.width = cv.height = size;
      const lg = cv.getContext( '2d' )!;
      lg.translate( size / 2, size / 2 );
      lg.beginPath();
      for ( let q = 0; q <= 10; q++ ) {
        const a = -Math.PI / 2 + q / 10 * Math.PI * 2;
        const rr = q % 2 ? size * 0.2 : size * ( q === 0 || q === 10 ? 0.46 : 0.4 );
        const px = Math.cos( a ) * rr, py = Math.sin( a ) * rr * 0.92;
        q ? lg.quadraticCurveTo( Math.cos( a - 0.3 ) * rr * 1.05, Math.sin( a - 0.3 ) * rr, px, py ) : lg.moveTo( px, py );
      }
      lg.closePath();
      const fg = lg.createRadialGradient( 0, 0, 0, 0, 0, size * 0.45 );
      fg.addColorStop( 0, this.rgba( this.mix( tint, [ 20, 10, 16 ], 0.2 ), 1 ) );
      fg.addColorStop( 1, this.rgba( this.mix( tint, [ 255, 236, 210 ], 0.15 ), 1 ) );
      lg.fillStyle = fg;
      lg.fill();
      lg.strokeStyle = this.rgba( this.mix( tint, [ 30, 18, 20 ], 0.4 ), 0.6 );
      lg.lineWidth = 1;
      for ( let q = 0; q < 5; q++ ) { const a = -Math.PI / 2 + q / 5 * Math.PI * 2; lg.beginPath(); lg.moveTo( 0, 0 ); lg.lineTo( Math.cos( a ) * size * 0.34, Math.sin( a ) * size * 0.32 ); lg.stroke(); }
      leafCache.set( key, cv );
      return cv;
    };
    // one plane tree, the size it really is (owner): a trunk forking into branches; its crown a crisp dark
    // mass of overlapping clumps, then hundreds of real leaves over it, lit by the sky at the top, by the
    // lamps underneath, darker within; far off a simple crisp shape
    const tree = ( x: number, z: number, hgt: number, base: RGB ) => {
      const s = F / z;
      const [ bx, by ] = P( x, 0, z ), [ cx, cy ] = P( x, hgt * 0.64, z );
      const r = Math.max( 0.8, s * hgt * 0.3 );
      const rnd = this.seededLocal( Math.floor( x * 13 + z * 7 ) );
      const dark = this.mix( base, [ 22, 12, 22 ], 0.5 );
      if ( r < 2.2 ) {
        g.fillStyle = this.rgba( dark, 1 );
        g.beginPath(); g.arc( cx, cy, Math.max( 0.7, r ), 0, Math.PI * 2 ); g.fill();
        g.fillStyle = this.rgba( base, 1 );
        g.beginPath(); g.arc( cx - r * 0.2, cy - r * 0.25, Math.max( 0.5, r * 0.55 ), 0, Math.PI * 2 ); g.fill();
        return;
      }
      // the trunk and its fork
      g.strokeStyle = 'rgb(54,40,44)';
      g.lineCap = 'round';
      g.lineWidth = Math.max( 0.8, s * 0.55 );
      const [ , fy ] = P( x, hgt * 0.38, z );
      g.beginPath(); g.moveTo( bx, by ); g.lineTo( bx, fy ); g.stroke();
      g.lineWidth = Math.max( 0.6, s * 0.28 );
      for ( const d of [ -1, 1, 0 ] ) {
        const [ ex, ey ] = P( x + d * hgt * 0.16, hgt * ( 0.55 + rnd() * 0.12 ), z );
        g.beginPath(); g.moveTo( bx, fy ); g.quadraticCurveTo( bx + ( ex - bx ) * 0.3, ( fy + ey ) / 2, ex, ey ); g.stroke();
      }
      // the crown's mass: crisp overlapping clumps
      const n = Math.min( 16, 6 + Math.floor( r / 3 ) );
      const clumps: [ number, number, number ][] = [];
      for ( let q = 0; q < n; q++ ) {
        const a = rnd() * Math.PI * 2, d = Math.sqrt( rnd() ) * r * 0.6;
        clumps.push( [ cx + Math.cos( a ) * d * 1.1, cy + Math.sin( a ) * d * 0.78, r * ( 0.4 + rnd() * 0.2 ) ] );
      }
      g.fillStyle = this.rgba( dark, 1 );
      g.beginPath();
      for ( const [ qx, qy, qr ] of clumps ) { g.moveTo( qx + qr, qy ); g.arc( qx, qy, qr, 0, Math.PI * 2 ); }
      g.fill();
      // the leaves, back to front: the deep ones darker, the top lit by the sky, the underside warmed by
      // the lamps
      const lit = this.mix( base, this.mix( sky2, rose, 0.5 ), 0.3 ), lamp = this.mix( base, [ 255, 196, 120 ], 0.35 );
      const count = Math.min( 420, Math.floor( r * r * 0.32 ) );
      const ls = Math.max( 2, r * 0.16 );
      for ( let q = 0; q < count; q++ ) {
        const [ qx, qy, qr ] = clumps[ Math.floor( rnd() * clumps.length ) ];
        const a = rnd() * Math.PI * 2, d = Math.sqrt( rnd() ) * qr * 0.95;
        const lx = qx + Math.cos( a ) * d, ly = qy + Math.sin( a ) * d;
        const up = ( cy - ly ) / r;
        const depth = q / count;
        const tone = up > 0.25 ? this.mix( base, lit, Math.min( 1, up ) * 0.8 ) : up < -0.35 ? this.mix( base, lamp, Math.min( 1, -up ) * 0.7 ) : this.mix( base, dark, 0.35 * ( 1 - depth ) );
        const sz = ls * ( 0.75 + rnd() * 0.5 );
        g.save();
        g.translate( lx, ly );
        g.rotate( rnd() * Math.PI * 2 );
        g.drawImage( leaf( tone ), -sz / 2, -sz / 2, sz, sz );
        g.restore();
      }
    };
    // ---- the back layer ----
    const bk = canvas();
    g = bk.g;
    // the sky: plum high up, rose, then burning coral and peach at the horizon
    const sky = g.createLinearGradient( 0, 0, 0, hz );
    // the blue hour (owner's photograph): deep blue high up, violet, then pink glowing low
    // a little darker (owner): every stop steeped in the night
    const night: RGB = [ 14, 14, 40 ];
    sky.addColorStop( 0, this.rgba( this.mix( this.mix( sky2, [ 20, 40, 100 ], 0.55 ), night, 0.22 ), 1 ) );
    sky.addColorStop( 0.4, this.rgba( this.mix( this.mix( sky2, plum, 0.45 ), night, 0.2 ), 1 ) );
    sky.addColorStop( 0.75, this.rgba( this.mix( this.mix( rose, sky2, 0.25 ), night, 0.16 ), 1 ) );
    sky.addColorStop( 1, this.rgba( this.mix( this.mix( rose, peach, 0.35 ), night, 0.1 ), 1 ) );
    g.fillStyle = sky;
    g.fillRect( 0, 0, W, hz + 2 );
    // the sun's glow just under the horizon behind the tower
    {
      const gl = g.createRadialGradient( this.vx, hz, 0, this.vx, hz, H * 0.7 );
      gl.addColorStop( 0, this.rgba( this.mix( rose, white, 0.3 ), 0.55 ) );
      gl.addColorStop( 0.4, this.rgba( rose, 0.2 ) );
      gl.addColorStop( 1, this.rgba( rose, 0 ) );
      g.fillStyle = gl;
      g.fillRect( 0, 0, W, hz + 2 );
    }
    // the sky on its own canvas, the rest of the back layer on another over the clouds
    this.sky = bk.c;
    const mid = canvas();
    g = mid.g;
    const cityRise = ( z: number, x: number ) => Math.max( 0, Math.min( 1, ( z - 1500 ) / 6000 ) ) * ( 120 + 50 * Math.sin( x * 0.0008 + 1 ) + 30 * Math.sin( x * 0.0021 ) );
    // the city to the horizon: rooftops in rows, paler and lower the farther
    {
      const cr = this.seededLocal( 41 );
      for ( let z = 9000; z > 1300; z *= 0.97 ) {
        const col = inAir( [ 120, 80, 96 ], z, 0.95 );
        for ( let x = -6000; x < 6000; ) {
          const w = 30 + cr() * 60, h = 18 + cr() * 14;
          // the city on ground rising away toward its hills (owner: the skyline climbing as it recedes)
          const rise = cityRise( z, x );
          const [ ax, ay ] = P( x, rise + h, z ), [ bx2 ] = P( x + w, 0, z ), [ , gy ] = P( x, 0, z );
          if ( bx2 > -5 && ax < W + 5 ) {
            g.fillStyle = this.rgba( col, 1 );
            g.fillRect( ax, ay, bx2 - ax + 0.5, gy - ay + 0.5 );
            // its roofline: a mansard's slope on top, a few chimney stacks (owner: the silhouette's top)
            const [ , my ] = P( x, rise + h + 4, z );
            g.beginPath();
            g.moveTo( ax, ay ); g.lineTo( ax + ( bx2 - ax ) * 0.12, my ); g.lineTo( bx2 - ( bx2 - ax ) * 0.12, my ); g.lineTo( bx2, ay ); g.closePath();
            g.fill();
            if ( bx2 - ax > 3 ) {
              for ( let q = 0; q < 2; q++ ) {
                const cxp = ax + ( bx2 - ax ) * ( 0.25 + 0.5 * cr() );
                g.fillRect( cxp, my - Math.max( 0.6, F * 1.6 / z ), Math.max( 0.6, F * 1.2 / z ), Math.max( 0.6, F * 1.6 / z ) );
              }
            }
            // its lit windows, warm points in the dusk
            if ( cr() < 0.7 ) {
              const [ lx, ly ] = P( x + w * cr(), rise + h * ( 0.2 + cr() * 0.6 ), z );
              blob( lx, ly, Math.max( 0.5, F * 1.2 / z ), [ 255, 200, 130 ], 0.85 );
            }
          }
          x += w + cr() * 10;
        }
      }
      // the Dôme des Invalides at the left (Napoleon's tomb), drawn as it is: the church's square body,
      // its portico, the drum ringed with columns, the gilded ribbed dome, the lantern and its spire; lit
      {
        const dz = 1900, dx = -820;
        const stoneD = inAir( [ 150, 120, 120 ], dz, 0.55 ), stoneL = inAir( [ 196, 168, 160 ], dz, 0.5 );
        const gold = inAir( [ 232, 186, 100 ], dz, 0.4 ), goldD = inAir( [ 168, 120, 64 ], dz, 0.45 );
        const Q = ( x0: number, y0: number, x1: number, y1: number, fill: string ) => poly( [ P( dx + x0, y0, dz ), P( dx + x1, y0, dz ), P( dx + x1, y1, dz ), P( dx + x0, y1, dz ) ], fill );
        // the body and the portico's pediment
        Q( -60, 0, 60, 26, this.rgba( stoneD, 1 ) );
        Q( -22, 0, 22, 30, this.rgba( stoneL, 1 ) );
        poly( [ P( dx - 24, 30, dz ), P( dx + 24, 30, dz ), P( dx, 38, dz ) ], this.rgba( stoneL, 1 ) );
        // the drum, its columns, its windows lit
        Q( -26, 26, 26, 52, this.rgba( stoneD, 1 ) );
        for ( let c = -24; c <= 24; c += 4 ) { Q( c - 0.7, 27, c + 0.7, 50, this.rgba( stoneL, 1 ) ); }
        for ( let c = -22; c <= 22; c += 8 ) { Q( c - 1.2, 32, c + 1.2, 44, 'rgb(255,204,140)' ); }
        Q( -27, 50, 27, 53, this.rgba( stoneL, 1 ) );
        // the dome: gilded ribs on a gold shell, lit from below by the floodlights
        const domePts: [ number, number ][] = [];
        for ( let a = 0; a <= Math.PI + 0.001; a += 0.04 ) { domePts.push( P( dx + Math.cos( a ) * 24, 53 + Math.pow( Math.sin( a ), 0.8 ) * 30, dz ) ); }
        const [ , dTop ] = P( dx, 83, dz ), [ , dBot ] = P( dx, 53, dz );
        const dg = g.createLinearGradient( 0, dTop, 0, dBot );
        dg.addColorStop( 0, this.rgba( goldD, 1 ) );
        dg.addColorStop( 1, this.rgba( gold, 1 ) );
        poly( domePts, dg );
        g.strokeStyle = this.rgba( goldD, 1 );
        g.lineWidth = Math.max( 0.4, F * 0.5 / dz );
        for ( let rib = -4; rib <= 4; rib++ ) {
          g.beginPath();
          for ( let a = 0; a <= Math.PI / 2 + 0.001; a += 0.05 ) {
            const u = Math.cos( a ) * ( rib / 4.5 );
            const [ px, py ] = P( dx + u * 24, 53 + Math.pow( Math.sin( Math.PI / 2 - a * 0 + 0 ), 1 ) * 0 + Math.pow( 1 - u * u, 0.5 ) * 30 * Math.sin( a ), dz );
            a ? g.lineTo( px, py ) : g.moveTo( px, py );
          }
          g.stroke();
        }
        // the lantern and the spire
        Q( -3.5, 82, 3.5, 92, this.rgba( gold, 1 ) );
        poly( [ P( dx - 2, 92, dz ), P( dx + 2, 92, dz ), P( dx, 107, dz ) ], this.rgba( gold, 1 ) );
        const [ gx, gy ] = P( dx, 65, dz );
        const glowD = g.createRadialGradient( gx, gy, 0, gx, gy, F * 60 / dz );
        glowD.addColorStop( 0, 'rgba(255,210,140,0.25)' );
        glowD.addColorStop( 1, 'rgba(255,210,140,0)' );
        g.fillStyle = glowD;
        g.fillRect( gx - F * 60 / dz, gy - F * 60 / dz, F * 120 / dz, F * 120 / dz );
      }
      // Saint-Sulpice's two towers on the skyline
      {
        const c1 = inAir( [ 120, 96, 110 ], 3800, 0.75 );
        const sz = 3800, sx0 = -1500, sb = cityRise( sz, sx0 );
        for ( const dx of [ -14, 14 ] ) { poly( [ P( sx0 + dx - 6, sb, sz ), P( sx0 + dx + 6, sb, sz ), P( sx0 + dx + 6, sb + 70, sz ), P( sx0 + dx - 6, sb + 70, sz ) ], this.rgba( c1, 1 ) ); }
        poly( [ P( sx0 - 20, sb, sz ), P( sx0 + 20, sb, sz ), P( sx0 + 20, sb + 34, sz ), P( sx0 - 20, sb + 34, sz ) ], this.rgba( c1, 1 ) );
      }
      // the city's lights along the horizon behind: streets in strings of warm points, lit windows
      {
        const cl2 = this.seededLocal( 43 );
        for ( let z = 8500; z > 1400; z *= 0.94 ) {
          for ( let x = -6000; x < 6000; x += 18 + cl2() * 40 ) {
            const [ px, py ] = P( x, cityRise( z, x ) + 1 + cl2() * 26, z );
            if ( px < -5 || px > W + 5 ) { continue; }
            blob( px, py, Math.max( 0.5, F * ( 1 + cl2() * 1.5 ) / z ), cl2() < 0.8 ? [ 255, 206, 140 ] : [ 255, 236, 210 ], 0.55 + cl2() * 0.4 );
          }
        }
      }
    }
    // the Champ de Mars: its long lawns and paths running to the tower and beyond
    ground( -1200, 1200, 560, 1700, this.rgba( inAir( [ 96, 70, 80 ], 1100, 0.6 ), 1 ) );
    // the Champ de Mars ends behind the tower at a road across (owner), lit along its length
    // the lawns under the tower a deeper green (owner)
    ground( -110, 110, 560, 1120, this.rgba( inAir( [ 52, 78, 46 ], 1000, 0.45 ), 1 ) );
    ground( -18, 18, 560, 1120, this.rgba( inAir( [ 120, 100, 104 ], 1000, 0.5 ), 1 ) );
    ground( -233, 233, 1120, 1150, this.rgba( inAir( [ 70, 62, 76 ], 1135, 0.5 ), 1 ) );
    {
      const rl = this.seededLocal( 67 );
      // a solid set of trees behind the tower (owner): three close rows, far one first, no gap
      for ( const z of [ 1182, 1170, 1158 ] ) {
        for ( let x = -236 + ( z % 2 ) * 3; x < 236; x += 6 + rl() * 2 ) {
          tree( x, z, 16 + rl() * 3, inAir( this.mix( [ 52, 82, 44 ], plum, 0.12 ), z, 0.5 ) );
        }
      }
      for ( let x = -230; x < 230; x += 14 + rl() * 20 ) {
        const [ px, py ] = P( x, 0.8, 1128 + rl() * 18 );
        blob( px, py, Math.max( 0.6, F * 0.8 / 1135 ), rl() < 0.5 ? [ 255, 236, 210 ] : [ 255, 80, 70 ], 0.8 );
      }
    }
    // ---- the Eiffel Tower, from a true silhouette (owner: find a quality drawing): "Eiffel Tower
    // Silhouette" by GDJ, Open Clip Art, CC0 (Wikimedia Commons), 125 m wide at its foot and 330 m high,
    // set up as a flat face at the tower's distance; dark iron with its lattice cut through it so the sky
    // shows, its platforms' belts; and the same outline for its illumination layer ----
    {
      // in 3D (owner: the silhouette alone was flat): the same outline as the tower's front face 62 m
      // before its middle and its back face 62 m behind, the back one smaller, lower and hazier, seen
      // through the arch and between the legs; the platforms' undersides between the two, seen from below
      const tzMid = TOWER_Z, half = 62 * TOWER_SCALE;
      // the back face set farther off than the real depth so it shows smaller beside the front one (owner: a
      // stronger 3D feel)
      const backZ = tzMid + half * 2.4;
      const shape = new Path2D( EIFFEL_D );
      const U = 1920 / 330;
      const ironBase: RGB = [ 44, 36, 48 ];
      const faceAt = ( z: number ) => { const [ , gy ] = P( 0, 0, z ); return { s: TOWER_SCALE * F / z, gy: gy + TOWER_DROP }; };
      const placeAt = ( c: CanvasRenderingContext2D, z: number ) => {
        const { s: sz, gy } = faceAt( z );
        c.translate( this.vx, gy );
        c.scale( sz / U, sz / U );
        c.translate( -368, -1920 );
      };
      // an open lattice inside the outline (owner: the gaps between the girders show the sky): crossing
      // diagonals of iron, level ties, the heavy edge girders along the outline, the platforms' belts
      const lattice = ( c: CanvasRenderingContext2D, iron: string | CanvasGradient, edge: string | CanvasGradient, shift: number, weight: number ) => {
        c.save();
        c.clip( shape );
        c.strokeStyle = iron;
        for ( let y = -800; y < 1920; y += 0 ) {
          const pitch = y < 400 ? 12 : y < 1250 ? 18 : 26;
          c.lineWidth = pitch * 0.16 * weight;
          c.beginPath();
          c.moveTo( 0, y + shift ); c.lineTo( 736, y + shift + 736 * 0.9 );
          c.moveTo( 736, y + shift ); c.lineTo( 0, y + shift + 736 * 0.9 );
          c.stroke();
          y += pitch;
        }
        c.lineWidth = 2.4 * weight;
        for ( let y = 40; y < 1900; y += 34 ) { c.beginPath(); c.moveTo( 0, y ); c.lineTo( 736, y ); c.stroke(); }
        // the edge girders: the outline stroked broad, half of it inside the clip
        c.strokeStyle = edge;
        c.lineWidth = 16 * weight;
        c.stroke( shape );
        c.restore();
        for ( const [ hm, th ] of [ [ 57, 7 ], [ 116, 5 ], [ 276, 3 ] ] as [ number, number ][] ) {
          const y1 = 1920 - hm * U, y0 = y1 - th * U;
          c.save();
          c.clip( shape );
          c.fillStyle = edge;
          c.fillRect( 0, y0, 736, y1 - y0 );
          c.restore();
        }
      };
      // the back face, leaning in toward the front one as the tower narrows (owner: only the legs are
      // farther off and smaller, the top meets the front's): each row of the outline at its own depth,
      // from backZ at the foot to the front face's depth at the top, by the tower's width at that row
      const tzF = tzMid - half;
      const widthAt: number[] = [];
      {
        const pr = document.createElement( 'canvas' ).getContext( '2d' )!;
        for ( let y = 0; y <= 1920; y += 8 ) {
          let l = -1, r2 = -1;
          for ( let x = 0; x <= 736; x += 4 ) { if ( pr.isPointInPath( shape, x, y ) ) { if ( l < 0 ) { l = x; } r2 = x; } }
          widthAt.push( l < 0 ? 0 : ( r2 - l ) / 736 );
        }
      }
      const backAt = ( y: number ) => tzF + ( backZ - tzF ) * widthAt[ Math.max( 0, Math.min( widthAt.length - 1, Math.round( y / 8 ) ) ) ];
      {
        // darker toward the foot so the back legs read under the arch (owner)
        const ironB = g.createLinearGradient( 0, 0, 0, 1920 );
        ironB.addColorStop( 0, this.rgba( this.mix( [ 36, 26, 28 ], this.mix( sky2, rose, 0.5 ), 0.2 ), 0.97 ) );
        ironB.addColorStop( 1, this.rgba( this.mix( [ 30, 22, 26 ], this.mix( sky2, rose, 0.5 ), 0.08 ), 1 ) );
        const band = 16;
        for ( let y0 = 0; y0 < 1920; y0 += band ) {
          const zb = backAt( y0 + band / 2 );
          const sb = TOWER_SCALE * F / zb;
          // this row where it falls on the stage at that depth, the face pinned at its top to the front's
          const gy = P( 0, 0, zb )[ 1 ] + TOWER_DROP;
          g.save();
          g.translate( this.vx, gy );
          g.scale( sb / U, sb / U );
          g.translate( -368, -1920 );
          g.beginPath(); g.rect( -10, y0 - 0.6, 756, band + 1.2 ); g.clip();
          lattice( g, ironB, ironB, 6, 0.8 );
          g.restore();
        }
      }
      // the platforms' undersides, between the faces
      for ( const [ hm ] of [ [ 57 ], [ 116 ], [ 276 ] ] ) {
        const wHalf = ( hm === 57 ? 40 : hm === 116 ? 22 : 6 ) * TOWER_SCALE, hs = hm * TOWER_SCALE;
        const zb = backAt( 1920 - hm * U );
        const a = P( -wHalf, hs, tzMid - half ), b = P( wHalf, hs, tzMid - half ), c = P( wHalf, hs, zb ), d = P( -wHalf, hs, zb );
        poly( [ a, b, c, d ].map( ( [ px, py ] ) => [ px, py + TOWER_DROP ] as [ number, number ] ), 'rgb(36,26,28)' );
      }
      const tz = tzMid - half;
      const s = TOWER_SCALE * F / tz;
      const groundY = P( 0, 0, tz )[ 1 ] + TOWER_DROP;
      const place = ( c: CanvasRenderingContext2D ) => placeAt( c, tz );
      g.save();
      place( g );
      // the iron's colour from the owner's photograph: a near-black warm silhouette against the sunset,
      // a touch of brown high up where the low sun catches it
      const bronze = g.createLinearGradient( 0, 0, 0, 1920 );
      bronze.addColorStop( 0, 'rgb(66,44,40)' );
      bronze.addColorStop( 0.5, 'rgb(48,32,32)' );
      bronze.addColorStop( 1, 'rgb(34,24,26)' );
      const bronzeEdge = g.createLinearGradient( 0, 0, 0, 1920 );
      bronzeEdge.addColorStop( 0, 'rgb(78,52,44)' );
      bronzeEdge.addColorStop( 0.5, 'rgb(58,38,36)' );
      bronzeEdge.addColorStop( 1, 'rgb(40,28,28)' );
      lattice( g, bronze, bronzeEdge, 0, 1 );
      // the arch's frieze of little arches on the first platform
      g.save();
      g.clip( shape );
      g.strokeStyle = 'rgb(84,58,50)';
      g.lineWidth = 1.6;
      for ( let x = 60; x < 680; x += 22 ) { g.beginPath(); g.arc( x + 11, 1920 - 57 * U - 2, 9, Math.PI, 0 ); g.stroke(); }
      g.restore();
      g.restore();
      // the edges' lamps and the sparkle's star points, found along the outline row by row
      const probe = document.createElement( 'canvas' ).getContext( '2d' )!;
      const lamps: [ number, number ][] = [];
      for ( let y = 8; y < 1900; y += 14 ) {
        let l = -1, r2 = -1;
        for ( let x = 0; x <= 736; x += 3 ) { if ( probe.isPointInPath( shape, x, y ) ) { if ( l < 0 ) { l = x; } r2 = x; } }
        if ( l < 0 ) { continue; }
        for ( const x of [ l, r2 ] ) { lamps.push( [ this.vx + ( x - 368 ) * s / U, groundY - ( 1920 - y ) * s / U ] ); }
      }
      this.stars = lamps.filter( ( _, i ) => i % 5 === 0 ).map( ( [ x, y ], i ) => [ x, y, ( i * 0.618 ) % 1 ] );
      this.beacon = [ this.vx, groundY - 1919 * s / U ];
      // the illumination: the whole iron body gold, its lattice brighter, the lamps along its edges
      const tl = canvas();
      const t2 = tl.g;
      t2.save();
      place( t2 );
      // not every line ablaze (owner): the edge girders and the belts warm gold, the lattice a faint glow
      lattice( t2, 'rgba(255,190,100,0.16)', 'rgba(255,186,90,0.6)', 0, 1 );
      t2.restore();
      for ( const [ px, py ] of lamps.filter( ( _, i ) => i % 3 === 0 ) ) {
        const rr = Math.max( 0.9, F * 0.6 / tz );
        const lg = t2.createRadialGradient( px, py, 0, px, py, rr );
        lg.addColorStop( 0, 'rgba(255,236,190,0.95)' );
        lg.addColorStop( 1, 'rgba(255,200,120,0)' );
        t2.fillStyle = lg;
        t2.fillRect( px - rr, py - rr, rr * 2, rr * 2 );
      }
      const ag = t2.createRadialGradient( this.vx, groundY - 8 * s, 0, this.vx, groundY - 8 * s, F * 60 / tz );
      ag.addColorStop( 0, 'rgba(255,200,130,0.6)' );
      ag.addColorStop( 1, 'rgba(255,200,130,0)' );
      t2.fillStyle = ag;
      t2.fillRect( this.vx - F * 60 / tz, groundY - 8 * s - F * 60 / tz, F * 120 / tz, F * 120 / tz );
      // (owner: no coloured lines on the tower, only its star-like lights) the layer is kept out
      this.towerLights = null;
      void tl;
      this.towerShape = shape;
      this.towerAt = [ this.vx, groundY, s / U ];
    }
    // ---- the Seine, its quays and the Pont d'Iéna ----
    {
      ground( -2000, 2000, 470, 560, this.rgba( this.mix( plum, coral, 0.35 ), 1 ) );
      // the sky's glow lying on the water
      const wg = g.createLinearGradient( 0, P( 0, 0, 560 )[ 1 ], 0, P( 0, 0, 470 )[ 1 ] );
      wg.addColorStop( 0, this.rgba( this.mix( peach, white, 0.3 ), 0.55 ) );
      wg.addColorStop( 1, this.rgba( this.mix( rose, plum, 0.3 ), 0.4 ) );
      ground( -2000, 2000, 470, 560, wg );
      // the lamps' light lying on the water in long trembling streaks
      {
        const sr = this.seededLocal( 71 );
        for ( let i = 0; i < 70; i++ ) {
          const x = ( sr() - 0.5 ) * 1600;
          const a = P( x, 0, 475 ), b = P( x, 0, 555 );
          const sw = Math.max( 0.8, F * 0.8 / 500 );
          const lg3 = g.createLinearGradient( 0, b[ 1 ], 0, a[ 1 ] );
          lg3.addColorStop( 0, 'rgba(255,210,150,0)' );
          lg3.addColorStop( 0.5, 'rgba(255,210,150,0.45)' );
          lg3.addColorStop( 1, 'rgba(255,210,150,0)' );
          g.fillStyle = lg3;
          g.fillRect( a[ 0 ] - sw, b[ 1 ], sw * 2, a[ 1 ] - b[ 1 ] );
        }
      }
      // the far quay and our quay with its road
      ground( -2000, 2000, 560, 575, 'rgb(150,112,112)' );
      // our quay's road across the view (owner: a real road in front of the blocks): the pavement, the
      // asphalt in two carriageways, the dashed centre line, the parapet along the river
      // it ends at the street along the blocks' fronts (owner)
      ground( -233, 233, 432, 440, 'rgb(150,124,124)' );
      ground( -233, 233, 440, 462, 'rgb(62,56,66)' );
      ground( -233, 233, 462, 470, 'rgb(160,134,132)' );
      for ( let x = -230; x < 230; x += 9 ) { ground( x, x + 4.5, 450.6, 451.4, 'rgba(240,226,200,0.75)' ); }
      ground( -233, 233, 440, 440.6, 'rgba(230,214,196,0.6)' );
      ground( -233, 233, 461.4, 462, 'rgba(230,214,196,0.6)' );
      // the parapet along the river on our quay, its lamp posts
      ground( -233, 233, 469, 470, 'rgb(196,170,164)' );
      for ( let x = -233; x < 233; x += 4 ) { const a = P( x, 0, 469.5 ), b = P( x + 4, 1, 469.5 ); g.fillStyle = 'rgb(186,158,152)'; g.fillRect( a[ 0 ], b[ 1 ], b[ 0 ] - a[ 0 ] + 0.3, a[ 1 ] - b[ 1 ] ); }
      for ( let x = -210; x <= 210; x += 30 ) {
        const [ lx, ly0 ] = P( x, 0, 468 ), [ , ly1 ] = P( x, 4.5, 468 );
        g.strokeStyle = 'rgb(40,32,40)';
        g.lineWidth = Math.max( 0.6, F * 0.15 / 468 );
        g.beginPath(); g.moveTo( lx, ly0 ); g.lineTo( lx, ly1 ); g.stroke();
        blob( lx, ly1, Math.max( 1, F * 0.8 / 468 ), [ 255, 210, 140 ], 0.9 );
      }
      // the bridge: its deck across the river on four low arches, lamps along it
      const deck = 9, bw = 18;
      poly( [ P( -bw, deck, 470 ), P( bw, deck, 470 ), P( bw, deck, 560 ), P( -bw, deck, 560 ) ], 'rgb(104,82,92)' );
      for ( let i = 0; i < 5; i++ ) {
        const za = 470 + i * 18, zb = za + 18;
        for ( const side of [ -1, 1 ] ) {
          const x = side * bw;
          const pts: [ number, number ][] = [ P( x, deck, za ), P( x, deck, zb ) ];
          for ( let a = 0; a <= Math.PI; a += 0.2 ) { pts.push( P( x, 2 + Math.sin( a ) * 5, zb - ( zb - za ) * a / Math.PI ) ); }
          poly( pts, side < 0 ? 'rgb(150,112,112)' : 'rgb(170,128,124)' );
        }
      }
      // its parapets, the shade under the deck's edges
      for ( const x of [ -bw, bw ] ) {
        poly( [ P( x, deck, 470 ), P( x, deck + 1.1, 470 ), P( x, deck + 1.1, 560 ), P( x, deck, 560 ) ], 'rgb(200,164,158)' );
        poly( [ P( x, deck - 1.2, 470 ), P( x, deck, 470 ), P( x, deck, 560 ), P( x, deck - 1.2, 560 ) ], 'rgb(80,56,66)' );
      }
      for ( let zl = 474; zl < 560; zl += 12 ) {
        for ( const x of [ -bw + 0.5, bw - 0.5 ] ) {
          const [ lx, ly ] = P( x, deck + 4, zl );
          blob( lx, ly, Math.max( 1, F * 0.6 / zl ), [ 255, 214, 150 ], 0.9 );
        }
      }
    }
    this.back = mid.c;
    // ---- the front layer: what stands nearer than the quay ----
    const fr = canvas();
    g = fr.g;
    // the ground of the Trocadéro and the avenues to either side
    ground( -2000, 2000, 120, 432, 'rgb(88,60,72)' );
    for ( const side of [ -1, 1 ] ) {
      ground( side * 85, side * 100, 120, 440, 'rgb(70,56,66)' );
      ground( side * 75, side * 85, 120, 440, 'rgb(150,118,120)' );
    }
    // the lawns sloping down beside the pool, mown in broad stripes, the low hedges along the water, the
    // gravel paths
    for ( const side of [ -1, 1 ] ) {
      const lg = g.createLinearGradient( 0, P( 0, 0, 440 )[ 1 ], 0, H );
      lg.addColorStop( 0, 'rgb(76,92,64)' );
      lg.addColorStop( 1, 'rgb(58,78,52)' );
      ground( side * 32, side * 72, 132, 430, lg );
      for ( let z = 132; z < 430; z += 14 ) { ground( side * 32, side * 72, z, z + 7, 'rgba(255,240,220,0.035)' ); }
      ground( side * 26, side * 32, 132, 430, 'rgb(170,148,140)' );
      ground( side * 72, side * 75, 132, 430, 'rgb(170,148,140)' );
      // the hedge, a low dark green wall along the gravel
      for ( let z = 430; z > 132; z -= 3 ) {
        const a = P( side * 32.5, 0, z ), b = P( side * 32.5, 1, z ), c = P( side * 32.5, 1, z + 3 ), d = P( side * 32.5, 0, z + 3 );
        poly( [ a, b, c, d ], 'rgb(44,62,44)' );
      }
      poly( [ P( side * 32.5, 1, 132 ), P( side * 34, 1, 132 ), P( side * 34, 1, 430 ), P( side * 32.5, 1, 430 ) ], 'rgb(62,84,58)' );
    }
    // the pool, as it is: its pale stone rim, the water holding the blue hour's sky and the tower's
    // reflection, faint ripples across it; at our end the stepped cascade falling into it from the terrace
    {
      ground( -26, 26, 132, 432, 'rgb(206,188,182)' );
      ground( -24.5, 24.5, 150, 425, 'rgb(150,130,128)' );
      const water = () => { const pts: [ number, number ][] = [ P( -24, 0, 150 ), P( 24, 0, 150 ), P( 24, 0, 424 ), P( -24, 0, 424 ) ]; return pts; };
      const pg = g.createLinearGradient( 0, P( 0, 0, 424 )[ 1 ], 0, P( 0, 0, 150 )[ 1 ] );
      pg.addColorStop( 0, this.rgba( this.mix( rose, peach, 0.3 ), 1 ) );
      pg.addColorStop( 0.45, this.rgba( this.mix( rose, sky2, 0.5 ), 1 ) );
      pg.addColorStop( 1, this.rgba( this.mix( sky2, [ 20, 40, 100 ], 0.55 ), 1 ) );
      poly( water(), pg );
      g.save();
      g.beginPath();
      water().forEach( ( [ x, y ], i ) => i ? g.lineTo( x, y ) : g.moveTo( x, y ) );
      g.closePath();
      g.clip();
      // the tower's reflection: its outline mirrored below the water's plane, faint and broken by ripples
      if ( this.towerShape ) {
        const tz = TOWER_Z - 62 * TOWER_SCALE, U = 1920 / 330, s2 = TOWER_SCALE * F / tz;
        const [ , groundY ] = P( 0, 0, tz );
        g.save();
        g.beginPath();
        for ( let z = 152; z < 424; z *= 1.018 ) { const a = P( -24, 0, z ), b = P( 24, 0, z * 1.009 ); g.rect( a[ 0 ], b[ 1 ], b[ 0 ] - a[ 0 ], a[ 1 ] - b[ 1 ] ); }
        g.clip();
        g.translate( this.vx, groundY );
        g.scale( s2 / U, -s2 / U );
        g.translate( -368, -1920 );
        g.fillStyle = 'rgba(40,30,50,0.14)';
        g.fill( this.towerShape );
        g.restore();
      }
      // ripples: fine light lines across the water, closer together far off
      for ( let z = 160; z < 420; z *= 1.035 ) {
        const a = P( -24, 0, z ), b = P( 24, 0, z );
        g.strokeStyle = 'rgba(255,240,250,0.12)';
        g.lineWidth = 0.6;
        g.beginPath(); g.moveTo( a[ 0 ], a[ 1 ] ); g.lineTo( b[ 0 ], b[ 1 ] ); g.stroke();
      }
      g.restore();
      // the cascade at our end, inside the pool's rim (owner: the steps spilled over), seen from above as
      // it descends away from us: five low stone treads with the water running over them, each lip a bright
      // line of foam where it pours to the next
      for ( let st = 0; st < 5; st++ ) {
        const z0 = 134 + st * 3.2, z1 = z0 + 3.2, y = 0.5 - st * 0.1;
        poly( [ P( -22, y, z0 ), P( 22, y, z0 ), P( 22, y, z1 ), P( -22, y, z1 ) ], 'rgb(190,172,168)' );
        const flow = g.createLinearGradient( 0, P( 0, y, z0 )[ 1 ], 0, P( 0, y, z1 )[ 1 ] );
        flow.addColorStop( 0, this.rgba( this.mix( sky2, rose, 0.45 ), 0.85 ) );
        flow.addColorStop( 1, this.rgba( this.mix( rose, white, 0.3 ), 0.85 ) );
        poly( [ P( -20.5, y + 0.02, z0 + 0.2 ), P( 20.5, y + 0.02, z0 + 0.2 ), P( 20.5, y + 0.02, z1 - 0.1 ), P( -20.5, y + 0.02, z1 - 0.1 ) ], flow );
        const a = P( -20.5, y + 0.02, z1 - 0.05 ), b = P( 20.5, y + 0.02, z1 - 0.05 );
        g.strokeStyle = 'rgba(255,250,252,0.95)';
        g.lineWidth = Math.max( 1, F * 0.2 / z1 );
        g.beginPath(); g.moveTo( a[ 0 ], a[ 1 ] ); g.lineTo( b[ 0 ], b[ 1 ] ); g.stroke();
      }
      // the stairs down either side of the cascade, within the rim
      for ( const side of [ -1, 1 ] ) {
        for ( let st = 0; st < 10; st++ ) {
          const z0 = 134 + st * 1.6;
          poly( [ P( side * 22.3, 0, z0 ), P( side * 25.5, 0, z0 ), P( side * 25.5, 0, z0 + 1.6 ), P( side * 22.3, 0, z0 + 1.6 ) ], st % 2 ? 'rgb(214,196,190)' : 'rgb(184,166,162)' );
        }
      }
      // the gilded statues on their plinths at the cascade's sides
      for ( const sx of [ -30, 30 ] ) {
        const pb = P( sx, 0, 136 ), pt = P( sx, 2.2, 136 ), st2 = P( sx, 4.6, 136 );
        const pw = F * 1.1 / 136;
        g.fillStyle = 'rgb(186,166,160)';
        g.fillRect( pb[ 0 ] - pw, pt[ 1 ], pw * 2, pb[ 1 ] - pt[ 1 ] );
        const grd = g.createLinearGradient( 0, st2[ 1 ], 0, pt[ 1 ] );
        grd.addColorStop( 0, 'rgb(250,206,120)' );
        grd.addColorStop( 1, 'rgb(180,130,60)' );
        g.fillStyle = grd;
        g.beginPath();
        g.moveTo( pt[ 0 ] - pw * 0.6, pt[ 1 ] );
        g.quadraticCurveTo( pt[ 0 ] - pw * 0.7, ( pt[ 1 ] + st2[ 1 ] ) / 2, pt[ 0 ] - pw * 0.25, st2[ 1 ] + pw * 0.5 );
        g.arc( pt[ 0 ], st2[ 1 ] + pw * 0.3, pw * 0.3, Math.PI, 0 );
        g.quadraticCurveTo( pt[ 0 ] + pw * 0.7, ( pt[ 1 ] + st2[ 1 ] ) / 2, pt[ 0 ] + pw * 0.6, pt[ 1 ] );
        g.closePath();
        g.fill();
      }
    }
    // the streets along the blocks' fronts, under the trees (owner: the trees were under the road)
    for ( const side of [ -1, 1 ] ) {
      // the street along their fronts (owner): pavement, asphalt, the dashed line, its lamps; in
      // perspective it runs as a diagonal down to us
      // unbroken along the whole row (owner)
      for ( const [ za, zb ] of [ [ 140, 1300 ] ] ) {
        ground( side * 200, side * 205, za, zb, 'rgb(150,124,124)' );
        ground( side * 205, side * 233, za, zb, 'rgb(62,56,66)' );
        ground( side * 233, side * 240, za, zb, 'rgb(160,134,132)' );
        for ( let z = za + 5; z < zb; z += 9 ) { ground( side * 218.6, side * 219.4, z, Math.min( zb, z + 4.5 ), 'rgba(240,226,200,0.7)' ); }
      }
      for ( let z = 160; z < 1300; z += 26 ) {
        const [ lx, ly0 ] = P( side * 236, 0, z ), [ , ly1 ] = P( side * 236, 5, z );
        g.strokeStyle = 'rgb(40,32,40)';
        g.lineWidth = Math.max( 0.6, F * 0.15 / z );
        g.beginPath(); g.moveTo( lx, ly0 ); g.lineTo( lx, ly1 ); g.stroke();
        blob( lx, ly1, Math.max( 1.2, F * 0.9 / z ), [ 255, 210, 140 ], 0.9 );
      }
    }
    // the Haussmann blocks to either side, drawn before the trees so these stand in front of them (owner), their fronts facing the axis: cream stone, the slate mansard
    // with its dormers, the balconies' iron lines, warm windows lit here and there
    {
      const br = this.seededLocal( 53 );
      const stone: RGB[] = [ [ 230, 214, 200 ], [ 220, 201, 184 ], [ 234, 216, 200 ] ];
      // one row a side, on one line (owner)
      for ( const [ rowX, zA, zB ] of [ [ 240, 150, 1300 ] ] ) for ( const side of [ -1, 1 ] ) {
        // set back behind the avenues' trees, as in the photograph
        const xf = side * rowX;
        const blocks: [ number, number, RGB ][] = [];
        // from near us (only a wide screen reaches that far out, owner: the row runs on to its edges) to
        // far off
        for ( let z = zA; z < zB; ) { const len = 24 + br() * 20; blocks.push( [ z, z + len, stone[ Math.floor( br() * 3 ) ] ] ); z += len + 0.5; }
        for ( let i = blocks.length - 1; i >= 0; i-- ) {
          const [ z0, z1, st ] = blocks[ i ];
          const zm = ( z0 + z1 ) / 2;
          const wall = this.mix( inAir( st, zm, 0.6 ), plum, 0.35 );
          const hW = 19 + ( Math.sin( z0 * 0.37 ) * 0.5 + 0.5 ) * 2.5, hR = hW + 6;
          const facade = ( y0: number, y1: number, za: number, zb: number, fill: string ) => poly( [ P( xf, y1, za ), P( xf, y1, zb ), P( xf, y0, zb ), P( xf, y0, za ) ], fill );
          facade( 0, hW, z0, z1, this.rgba( wall, 1 ) );
          // the mansard (owner: as they really are): a steep zinc lower face rising from the cornice, a
          // shallow upper face above it catching the sky's light, the lead ridge on top
          const zinc: RGB = inAir( [ 92, 98, 122 ], zm, 0.6 ), zincTop: RGB = inAir( [ 138, 132, 160 ], zm, 0.6 );
          poly( [ P( xf, hW, z0 ), P( xf + side * 1.6, hW + 4.6, z0 ), P( xf + side * 1.6, hW + 4.6, z1 ), P( xf, hW, z1 ) ], this.rgba( zinc, 1 ) );
          poly( [ P( xf + side * 1.6, hW + 4.6, z0 ), P( xf + side * 5.5, hR, z0 ), P( xf + side * 5.5, hR, z1 ), P( xf + side * 1.6, hW + 4.6, z1 ) ], this.rgba( zincTop, 1 ) );
          poly( [ P( xf + side * 1.6, hW + 4.6, z0 ), P( xf + side * 1.6, hW + 4.9, z0 ), P( xf + side * 1.6, hW + 4.9, z1 ), P( xf + side * 1.6, hW + 4.6, z1 ) ], this.rgba( this.mix( zincTop, [ 255, 255, 255 ], 0.2 ), 1 ) );
          // the roof's end toward us, closed (owner): the mansard's profile across the building's depth
          poly( [ P( xf, hW, z0 ), P( xf + side * 1.6, hW + 4.6, z0 ), P( xf + side * 5.5, hR, z0 ), P( xf + side * 8.5, hR, z0 ), P( xf + side * 12.4, hW + 4.6, z0 ), P( xf + side * 14, hW, z0 ) ], this.rgba( this.mix( zinc, [ 30, 24, 40 ], 0.3 ), 1 ) );
          // the near end wall
          poly( [ P( xf, 0, z0 ), P( xf, hW, z0 ), P( xf + side * 14, hW, z0 ), P( xf + side * 14, 0, z0 ) ], this.rgba( this.mix( wall, [ 40, 20, 30 ], 0.3 ), 1 ) );
          const pxPerM = F / zm;
          const shade = this.rgba( this.mix( wall, [ 40, 24, 36 ], 0.35 ), 1 ), light = this.rgba( this.mix( wall, [ 255, 240, 230 ], 0.18 ), 1 );
          if ( pxPerM > 0.5 ) {
            const bays = Math.round( ( z1 - z0 ) / 4 );
            // the ground floor in rusticated stone: its tall arched shopfronts, lit or dark
            facade( 0, 4.4, z0, z1, this.rgba( this.mix( wall, [ 255, 240, 230 ], 0.08 ), 1 ) );
            for ( let b = 0; b < bays; b++ ) {
              const za = z0 + ( z1 - z0 ) * ( b + 0.15 ) / bays, zb = z0 + ( z1 - z0 ) * ( b + 0.85 ) / bays;
              const shop = br() < 0.16;
              facade( 0.2, 3.4, za, zb, shop ? 'rgb(255,196,120)' : this.rgba( this.mix( [ 50, 36, 46 ], wall, 0.2 ), 1 ) );
              if ( pxPerM > 2.5 ) {
                const pts: [ number, number ][] = [];
                for ( let a = 0; a <= Math.PI; a += 0.25 ) { pts.push( P( xf, 3.4 + Math.sin( a ) * 0.7, za + ( zb - za ) * ( 1 - Math.cos( a ) ) / 2 ) ); }
                poly( pts, shop ? 'rgb(255,196,120)' : this.rgba( this.mix( [ 50, 36, 46 ], wall, 0.2 ), 1 ) );
              }
            }
            // the cornice over the ground floor
            facade( 4.4, 4.9, z0, z1, light );
            // five floors of tall French windows, each in its pale stone surround, some lit warm behind
            // their curtains
            for ( let fl = 0; fl < 5; fl++ ) {
              const y0 = 5.4 + fl * 2.95, y1 = y0 + 2.1;
              for ( let b = 0; b < bays; b++ ) {
                const za = z0 + ( z1 - z0 ) * ( b + 0.28 ) / bays, zb = z0 + ( z1 - z0 ) * ( b + 0.72 ) / bays;
                if ( pxPerM > 1.6 ) { const dz = ( zb - za ) * 0.15; facade( y0 - 0.2, y1 + 0.35, za - dz, zb + dz, light ); }
                const litW = br() < 0.24;
                facade( y0, y1, za, zb, litW ? 'rgb(255,200,130)' : this.rgba( this.mix( [ 56, 42, 58 ], wall, 0.18 ), 1 ) );
                if ( litW && pxPerM > 2.2 ) { facade( y0, y1, za, za + ( zb - za ) * 0.25, 'rgba(230,150,110,0.6)' ); facade( y0, y1, zb - ( zb - za ) * 0.25, zb, 'rgba(230,150,110,0.6)' ); }
              }
              // the wrought iron balconies running the whole front on the second and fifth floors, a
              // small one under each window on the others
              if ( fl === 0 || fl === 3 ) {
                facade( y0 - 0.15, y0 + 0.75, z0, z1, 'rgba(34,26,32,0.55)' );
                facade( y0 + 0.7, y0 + 0.85, z0, z1, 'rgba(34,26,32,0.9)' );
                if ( pxPerM > 2.2 ) {
                  g.strokeStyle = 'rgba(34,26,32,0.8)';
                  g.lineWidth = 0.5;
                  for ( let zz = z0; zz < z1; zz += 0.5 ) { const a = P( xf, y0 - 0.15, zz ), b2 = P( xf, y0 + 0.75, zz ); g.beginPath(); g.moveTo( a[ 0 ], a[ 1 ] ); g.lineTo( b2[ 0 ], b2[ 1 ] ); g.stroke(); }
                }
              } else if ( pxPerM > 1.6 ) {
                for ( let b = 0; b < bays; b++ ) {
                  const za = z0 + ( z1 - z0 ) * ( b + 0.24 ) / bays, zb = z0 + ( z1 - z0 ) * ( b + 0.76 ) / bays;
                  facade( y0 - 0.1, y0 + 0.5, za, zb, 'rgba(34,26,32,0.6)' );
                }
              }
              // the string course between floors
              facade( y1 + 0.55, y1 + 0.7, z0, z1, shade );
            }
            // the main cornice under the roof
            facade( hW - 0.4, hW, z0, z1, light );
            facade( hW - 0.7, hW - 0.4, z0, z1, shade );
            // dormers in the mansard, each with its small pitched roof and pale frame
            for ( let b = 0; b < bays; b++ ) {
              const za = z0 + ( z1 - z0 ) * ( b + 0.35 ) / bays, zb = z0 + ( z1 - z0 ) * ( b + 0.65 ) / bays;
              const dx = xf + side * 0.9;
              poly( [ P( dx, hW + 4.2, za ), P( dx, hW + 4.2, zb ), P( dx, hW + 1.6, zb ), P( dx, hW + 1.6, za ) ], this.rgba( this.mix( wall, [ 255, 240, 230 ], 0.15 ), 1 ) );
              poly( [ P( dx, hW + 3.8, za + 0.1 ), P( dx, hW + 3.8, zb - 0.1 ), P( dx, hW + 2, zb - 0.1 ), P( dx, hW + 2, za + 0.1 ) ], br() < 0.3 ? 'rgb(255,200,130)' : 'rgb(64,58,80)' );
              poly( [ P( dx, hW + 4.2, za - 0.2 ), P( dx, hW + 4.2, zb + 0.2 ), P( dx, hW + 5.2, ( za + zb ) / 2 ) ], this.rgba( inAir( [ 80, 84, 108 ], zm, 0.6 ), 1 ) );
            }
            // the chimney stacks along the ridge, with their pots
            for ( let zc = z0 + 3; zc < z1 - 2; zc += 7 + br() * 4 ) {
              const cx2 = xf + side * 5.2;
              poly( [ P( cx2, hR, zc ), P( cx2, hR + 2.4, zc ), P( cx2, hR + 2.4, zc + 1.4 ), P( cx2, hR, zc + 1.4 ) ], this.rgba( inAir( [ 168, 118, 104 ], zm, 0.6 ), 1 ) );
              for ( let q = 0; q < 3; q++ ) { poly( [ P( cx2, hR + 2.4, zc + 0.15 + q * 0.42 ), P( cx2, hR + 2.9, zc + 0.15 + q * 0.42 ), P( cx2, hR + 2.9, zc + 0.4 + q * 0.42 ), P( cx2, hR + 2.4, zc + 0.4 + q * 0.42 ) ], this.rgba( inAir( [ 190, 120, 96 ], zm, 0.6 ), 1 ) ); }
            }
          }
        }
      }
    }
    // the trees along the Champ de Mars before the tower's foot, over the streets (owner: they were under
    // the road)
    for ( let z = 980; z > 600; z -= 16 ) {
      for ( const x of [ -125, -110, 110, 125 ] ) { tree( x, z, 18, inAir( this.mix( [ 56, 86, 46 ], plum, 0.12 ), z, 0.5 ) ); }
    }
    // the lamps along the avenues and the gardens' paths, warm in the dusk, under the trees (owner)
    for ( let z = 420; z > 140; z -= 22 ) {
      for ( const x of [ -88, 88, -28, 28 ] ) {
        const [ lx, ly0 ] = P( x, 0, z ), [ , ly1 ] = P( x, 4.5, z );
        g.strokeStyle = 'rgb(40,32,40)';
        g.lineWidth = Math.max( 0.6, F * 0.15 / z );
        g.beginPath(); g.moveTo( lx, ly0 ); g.lineTo( lx, ly1 ); g.stroke();
        blob( lx, ly1, Math.max( 1.2, F * 0.9 / z ), [ 255, 210, 140 ], 0.9 );
      }
    }
    // the rows of autumn trees along the avenues, far ones first
    {
      const tr = this.seededLocal( 47 );
      // the Champ de Mars' clipped summer trees, as in the owner's photograph: deep greens against the dusk
      const autumn: RGB[] = [ [ 52, 84, 44 ], [ 60, 92, 48 ], [ 44, 72, 40 ], [ 66, 96, 50 ], [ 48, 78, 42 ] ];
      const trees: [ number, number, number, RGB ][] = [];
      for ( let z = 440; z > 125; z -= 9 + tr() * 4 ) {
        for ( const x of [ -112, -104, 104, 112, -78, 78 ] ) {
          trees.push( [ x + ( tr() - 0.5 ) * 2, z, 14 + tr() * 3.5, autumn[ Math.floor( tr() * autumn.length ) ] ] );
        }
      }
      trees.sort( ( a, b ) => b[ 1 ] - a[ 1 ] );
      for ( const [ x, z, h, c ] of trees ) { tree( x, z, h, this.mix( c, plum, 0.12 ) ); }
    }
    // the stone balustrade along the terrace at our feet, the near lamp posts
    {
      ground( -2000, 2000, 120, 132, 'rgb(186,160,156)' );
      g.strokeStyle = 'rgb(200,176,170)';
      g.lineWidth = Math.max( 1, F * 0.25 / 128 );
      for ( let x = -400; x < 400; x += 1.4 ) {
        const [ ax, ay ] = P( x, 0, 128 ), [ , ty ] = P( x, 1, 128 );
        if ( ax < -5 || ax > W + 5 ) { continue; }
        g.beginPath(); g.moveTo( ax, ay ); g.lineTo( ax, ty ); g.stroke();
      }
      const [ rx0, ry ] = P( -400, 1, 128 ), [ rx1 ] = P( 400, 1, 128 );
      g.fillStyle = 'rgb(214,190,184)';
      g.fillRect( rx0, ry - F * 0.25 / 128, rx1 - rx0, F * 0.3 / 128 );
      for ( const x of [ -80, -40, 40, 80 ] ) {
        const [ lx, ly0 ] = P( x, 0, 140 ), [ , ly1 ] = P( x, 5, 140 );
        g.strokeStyle = 'rgb(40,32,40)';
        g.lineWidth = Math.max( 1, F * 0.2 / 140 );
        g.beginPath(); g.moveTo( lx, ly0 ); g.lineTo( lx, ly1 ); g.stroke();
        blob( lx, ly1, F * 0.6 / 140, [ 255, 214, 150 ], 0.95 );
      }
    }
    this.front = fr.c;

    // ---- the clouds: level streaks lit from below by the sunset, by the stage's height ----
    const cl = canvas();
    const cr2 = this.seededLocal( 29 );
    for ( let i = 0; i < 9; i++ ) {
      const cx = cr2() * W, cy = H * ( 0.06 + cr2() * 0.36 ), cw = ( 0.3 + cr2() * 0.5 ) * H, ch = ( 0.012 + cr2() * 0.02 ) * H;
      const low = cy / ( H * 0.42 );
      // heavy dusk clouds (owner's photograph): dark violet blue, their undersides catching pink
      const top: RGB = this.mix( this.mix( sky2, [ 30, 30, 70 ], 0.6 ), plum, 0.3 ), under: RGB = this.mix( rose, peach, 0.2 + 0.3 * ( 1 - low ) );
      for ( let q = 0; q < 26; q++ ) {
        const a = cr2() * 2 - 1;
        const px = cx + a * cw * 0.5, py = cy + ( cr2() - 0.5 ) * ch, pr = ch * ( 0.8 + cr2() * 1.2 ) * ( 1 - Math.abs( a ) * 0.5 );
        for ( const dx of [ -W, 0, W ] ) {
          cl.g.save();
          cl.g.translate( px + dx, py );
          cl.g.scale( 3.2, 1 );
          const pg = cl.g.createRadialGradient( 0, 0, 0, 0, 0, pr );
          pg.addColorStop( 0, this.rgba( this.mix( top, under, 0.25 ), 0.75 ) );
          pg.addColorStop( 1, this.rgba( top, 0 ) );
          cl.g.fillStyle = pg;
          cl.g.fillRect( -pr, -pr, pr * 2, pr * 2 );
          const ug = cl.g.createRadialGradient( 0, pr * 0.35, 0, 0, pr * 0.35, pr * 0.7 );
          ug.addColorStop( 0, this.rgba( under, 0.45 ) );
          ug.addColorStop( 1, this.rgba( under, 0 ) );
          cl.g.fillStyle = ug;
          cl.g.fillRect( -pr, -pr * 0.35, pr * 2, pr * 1.4 );
          cl.g.restore();
        }
      }
    }
    this.clouds = cl.c;
    void k;
  }

  private seededLocal( seed: number ): () => number {
    let s = ( seed * 2654435761 ) >>> 0;
    return () => {
      s = ( s + 0x6D2B79F5 ) >>> 0;
      let t = Math.imul( s ^ ( s >>> 15 ), 1 | s );
      t = ( t + Math.imul( t ^ ( t >>> 7 ), 61 | t ) ) ^ t;
      return ( ( t ^ ( t >>> 14 ) ) >>> 0 ) / 4294967296;
    };
  }

  /** The colour circle's five, or Paris's own: plum, dusty rose, coral, peach, twilight blue. */
  private five(): RGB[] {
    if ( this.paletteColors.length >= 5 ) { return this.paletteColors.slice( 0, 5 ); }
    return [ [ 106, 60, 77 ], [ 213, 132, 163 ], [ 223, 117, 131 ], [ 251, 186, 119 ], [ 135, 161, 211 ] ];
  }
}
